import React, { Component } from 'react';
import classNames from 'classnames';
import ReactDOM from 'react-dom';
import 'react-widgets/lib/less/react-widgets.less';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';
import { SkyLightStateless } from 'react-skylight';
import ReactDataGrid from 'react-data-grid';
import { Data, Editors, Toolbar } from 'react-data-grid-addons';
import _, { isInteger } from 'lodash';
import { Field } from 'redux-form';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Input, Breadcrumb } from 'react-bootstrap';
import { I18n, Translate } from 'react-redux-i18n';
import moment from 'moment';
import axios from 'axios';

import GenericProductSuggest from '../../containers/Common/GenericProductSuggest';
import TypeRadios from '../../containers/Common/TypeRadios';
import { DatePicker, DisabledDatePicker } from '../Common/datePicker';
import { InputField, DisabledInputField } from '../Common/inputField';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import { DEFAULT_ERROR, UI_HEIGHT } from '../Common/constants';
import Spinner from '../../components/Widgets/spinner';
import ConfirmActionModal from '../Common/confirmActionModal';
import SetReceiveWeightModal from '../../containers/Inventories/setReceiveWeightModal';
import { Selection } from '../Common/selection';
import WarehouseDropdown from './warehouseDropdown';
import { convertLocalDate, timeTOYmdOrMdy } from '../Common/cleanDates';
import { numberWithCommas } from '../Common/numberWithCommas';
import checkPermission from '../Common/permissions';
import {
  ROOT_URL, ROOT_API_URL, companyCodeTitle, isSH, isABBLE, isGGI, isHO, isJRC, isHMM,
  isLAP, isCPG, isOLG, isVAK, isOCM, isSV, isVIP, isCCW,
} from '../../actions/root_url';
import warehouseManagementModal from '../Common/modals/warehouseManagement';

const DropDownEditor = Editors.DropDownEditor;
const { LocationSelectModal } = warehouseManagementModal;
const isEcity = ROOT_API_URL === "https://ctstage-scm.truckxi.com/api/"|| ROOT_API_URL === 'https://ct-scm.truckxi.com/api/' || ROOT_API_URL === "https://dev-scm.truckxi.com/api/";
const isMmDavis = ROOT_API_URL === 'https://mmdavis-scm.truckxi.com/api/' || ROOT_URL === 'https://mmdavis-scm.truckxi.com/api/';
const isTN =
  ROOT_API_URL === "https://tn-scm.truckxi.com/api/" ||
  ROOT_URL === "https://tn-scm.truckxi.com/api/";
const isUSPride = ROOT_API_URL === "https://uspride-scm.truckxi.com/api/" || ROOT_URL === "https://uspride-scm.truckxi.com/api/";

// import {buttonStyle, marginTopStyle, centerStyle} from '../Common/style'
const colWidth = isGGI ? 4 : 6;
const renderInputField = (props) => {
  const inputClass = classNames({ 'parsley-error': props.meta.touched && props.meta.error }, 'form-control');
  return (
    <div>
      {props.meta.touched && props.meta.error && <span className="parsley-error-message">{props.meta.error}</span>}
      <Input {...props.input} className={inputClass} type="text" placeholder={props.placeholder} />
    </div>
  );
};

const inputStyle = {
  display: 'block',
  width: '100%',
  height: '24px',
  padding: '2px 2px',
  fontSize: '12px',
  lineHeight: '1.52857',
  color: '#000',
  backgroundColor: '#fff',
  backgroundImage: 'none',
  border: '1px solid #555555',
  borderRadius: '3px',
  boxShadow: 'inset 0 1px 1px rgba(0, 0, 0, 0.075)',
  transition: 'border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s',
}

const renderDatePicker = props => (
  <DateTimePicker
    format="YYYY-MM-DD"
    defaultValue={null}
    time={false}
    onChange={name => props.input.onChange(name)}
    value={props.input.value || null}
  />
);

const Checkbox = props => {
  return (
    <input
      {...props.input}
      type="checkbox"
      value={!props.input.value ? "true" : "false"}
      checked={props.input.value === true || props.input.value === "true"}
      disabled={props.disabled}
    />
  );
}

const sortByLineID = (a, b) => parseFloat(a.PurchaseOrderLine_id) - parseFloat(b.PurchaseOrderLine_id);

class RowRenderer extends Component {
  // PropTypes: {
  //     onDoubleClick: React.PropTypes.func
  // };
  render() {
    return (<div onDoubleClick={() => { this.props.onDoubleClick(this.props.row); }}><ReactDataGrid.Row ref="row" {...this.props} /></div>);
  }
}

class DateEditor extends React.Component {
  constructor(props) {
      super(props);
      this.inputRef = null;
      this.state = {
        dropUp: false,
      }
  }

  componentDidMount() {
    let rect = this.getInputNode().getBoundingClientRect();
    let tableElement = document.getElementById('ReceiveForm-dataGrid2');
    let tableToBottom = tableElement.getBoundingClientRect().bottom;
    let distanceToBottom = tableToBottom - rect.bottom;
    if(distanceToBottom < 260) {
      this.setState({
        dropUp: true,
      })
    }
  }

  componentWillUnmount() {
    let cells = document.querySelectorAll('.react-grid-Cell').forEach(cell => {
      cell.style.zIndex = "unset";
    });
  }

  getStyle() {
      return {
          width: '100%'
      };
  }

  getValue() {
    let updated = {};
    let packageDate;
    if(this.getInputNode().querySelector('input').value) {
      packageDate = moment(this.getInputNode().querySelector('input').value).format('MM-DD-YYYY');
    } else {
      packageDate = moment().format('MM-DD-YYYY');
    }
    updated[this.props.column.key] = packageDate;
    return updated;
  }

  getInputNode() {
      return ReactDOM.findDOMNode(this.inputRef);
  }

  inheritContainerStyles() {
      return true;
  }
  render() {
    const {rowData} = this.props;
    return<DateTimePicker
    ref={ref => this.inputRef = ref}
    placeholder={'MM-DD-YYYY'}
    format="MM-DD-YYYY"
    className={'test-rw-input'}
    time={false}
    date={true}
    dropUp={this.state.dropUp}
    onChange={(date) => {
      this.getInputNode().querySelector('input').value = moment(date).format('MM-DD-YYYY');
      this.props.onCommit();
    }}
    onToggle={(e)=>{
      if(e == 'calendar') {
        let cell = document.querySelector('.react-grid-Cell.editing');
        cell.style.zIndex = 100;
      } else {
        let cell = document.querySelector('.react-grid-Cell.editing');
        cell.style.zIndex = 'unset';
      }
    }}
    onBlur={()=>{
       let cells = document.querySelectorAll('.react-grid-Cell').forEach(cell => {
          cell.style.zIndex = "unset";
        });
    }}
    value={rowData[this.props.column.key] ? new Date(rowData[this.props.column.key]): undefined}
    defaultValue={undefined}
    />
  }
}

class ReceiveForm extends Component {
    static contextTypes = {
      router: React.PropTypes.object,
    };

    constructor() {
      super();
      this.state = {
        tableHeight: window.innerHeight - UI_HEIGHT.twoLineButton - 50,

        confirmOpen: false,
        saveConfirmOpen: false,
        vendorOptions1: [],
            vendorOptions2: [],
        setWeightOpen: false,
        totalLoaded: null,
        rowChosen: -1,
        tableChosen: null,
        formProps: null,
        oldQty:0,
        inventories: {
          rows: [],
          selectedRows: [],
          filters: {},
          sortColumn: null,
          sortDirection: null,
        },

        receivedInventories: {
          rows: [],
          selectedRows: [],
          filters: {},
          sortColumn: null,
          sortDirection: null,
        },
        receiptNum: null,
        warehouseName: null,
        receiver: null,
        PONum: null,
        purchaser: null,
        vendorNum: null,
        vendorName: null,
        vendorDescription: null,
        vendorAdd: null,
        vendorContact: null,
        orderDate: null,
        ETADate: null,
        createTime: null,
        totalPrice: null,
        caseAction: null,
        MiscCost: 0,
        HandlingCost: 0,
        SyncAp: false,
        ShippingCost: 0,
        priceAdjustment: 0,
        ShareCost: false,
        InvoiceFinalPrice: 0,
        warehouseReceivePdf: true,
        filteredByItem: false,
        suggestValue: '',
        productSearchType: 'ProductNum',
        ProductNum: 0,
        selectedProduct: {
          product: {},
          Quantity: 1,
          UnitPrice: 0,
          productNote: '',
          newProductAdded: false,
        },

        isLocationSelectModalVisible: false,
        Company_id_id: null,
      };

      this.handleResize = this.handleResize.bind(this);
      this.openConfirm = this.openConfirm.bind(this);
      this.closeConfirm = this.closeConfirm.bind(this);
      this.openSetWeight = this.openSetWeight.bind(this);
      this.closeSetWeight = this.closeSetWeight.bind(this);
      this.completePurchaseOrder = this.completePurchaseOrder.bind(this);
      this.createReceive = this.createReceive.bind(this);
      this.setRows = this.setRows.bind(this);
      this.cancelSetRow = this.cancelSetRow.bind(this);
      this.moveOff = this.moveOff.bind(this);
      this.moveTo = this.moveTo.bind(this);
      this.handleFormSubmit = this.handleFormSubmit.bind(this);
      this.showSaveConfirm = this.showSaveConfirm.bind(this);
      this.showSaveConfirmAP = this.showSaveConfirmAP.bind(this);
      this.closeSaveConfirm = this.closeSaveConfirm.bind(this);

      this.setTextInputRef = element => {
        this.textInput = element;
      };

    }

    componentDidMount() {
      window.addEventListener('resize', this.handleResize);
      const { currentReceive } = this.props;
      if (currentReceive) {
        this.props.fetchReceiveDetail(currentReceive.PONum)
          .then((res) => {
            if (!isCPG && !isVIP) {
              this.props.setPostingDate(new Date(), 'receiveForm');
            }
            // if (isCPG) {
            //   this.props.setDefaultOfForm('InvoiceDate', new Date(), 'receiveForm');
            //   this.props.setDefaultOfForm('PostingDate', new Date(), 'receiveForm');
            // }
          });
      }

      let {vendorOptions1, vendorOptions2} = this.state;
      axios
      .get(
        `${ROOT_URL}v2/general/vendor?depth=1&fields=id,name,vendor_num,payment_term&is_active=true&order=name`,
          {
              headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
          }
      )
          .then(response => {
            if (response && response.data && response.data.vendors) {
              response.data.vendors.map(r => {
                vendorOptions1.push({label: r.name, value: r.id});
                vendorOptions2.push({label: r.vendor_num, value: r.id});
              });
            }
            this.setState({vendorOptions1, vendorOptions2});
          }, err => {
            if (err.status === 500 || err.status === 404) {
              err.data = DEFAULT_ERROR;
            }
            alert(err.data);
          }
          );
    }
    focus = () => {
      this.textInput.current.focus();
    }

    componentDidUpdate(prevProps, prevState) {
      if (prevProps.PostingDate !== this.props.PostingDate) {
        if (isCPG || isVIP) {
          this.props.setDefaultOfForm('InvoiceDate', this.props.PostingDate, 'receiveForm');
        }
      }
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
      this.props.resetCreateReceive();
    }

    // Once inventories are ready, reset state.
    componentWillReceiveProps(nextProps) {
      if (this.props.currentReceiveDetail !== nextProps.currentReceiveDetail) {
        this.setState({
          selectedWarehouse: { value: nextProps.currentReceiveDetail.Deliver_Warehouse_id_id },
          Company_id_id: nextProps.currentReceiveDetail.Company_id_id,
        });
        if (isCPG || isVIP) {
          const ETADate = nextProps.currentReceiveDetail.ETADate;
          this.props.setDefaultOfForm('InvoiceDate', new Date(ETADate), 'receiveForm');
          this.props.setDefaultOfForm('PostingDate', new Date(ETADate), 'receiveForm');
        }
      }
      if (this.props.Warehouse !== nextProps.Warehouse) {
        this.setState({
          selectedWarehouse: { ...nextProps.Warehouse },
        })
      }
      if (parseFloat(nextProps.MiscCost) !== this.props.MiscCost) { this.setState({ MiscCost: parseFloat(nextProps.MiscCost) }); }
      if (parseFloat(nextProps.HandlingCost) !== this.props.HandlingCost) { this.setState({ HandlingCost: parseFloat(nextProps.HandlingCost) }); }
      if (parseFloat(nextProps.ShippingCost) !== this.props.ShippingCost) { this.setState({ ShippingCost: parseFloat(nextProps.ShippingCost) }); }
      if (parseFloat(nextProps.priceAdjustment) !== this.props.priceAdjustment) {
        this.setState({ priceAdjustment: parseFloat(nextProps.priceAdjustment) });
      }
      if (nextProps.ShareCost !== this.props.ShareCost) { this.setState({ ShareCost: nextProps.ShareCost }); }

      if (parseFloat(nextProps.InvoiceFinalPrice) !== this.props.InvoiceFinalPrice) { this.setState({ InvoiceFinalPrice: parseFloat(nextProps.InvoiceFinalPrice) }); }
      if (parseFloat(nextProps.TaxRate) !== this.props.TaxRate) { this.setState({ TaxRate: parseFloat(nextProps.TaxRate) }); }
      if (parseFloat(nextProps.TotalCRV) !== this.props.TotalCRV) { this.setState({ TotalCRV: parseFloat(nextProps.TotalCRV) }); }

      if (nextProps.currentReceiveDetail && (nextProps.currentReceiveDetail != this.props.currentReceiveDetail)) {
        this.handleNewReceiveDetails(nextProps, false)
      }

      if (nextProps.warehouseReceivePdf && nextProps.warehouseReceivePdf !== this.props.warehouseReceivePdf) {
        this.setState({ PdfFrameLoaded: false });
      }
    }

    shouldComponentUpdate(nextProps, nextState) {
      if (nextState.PdfFrameLoaded !== this.state.PdfFrameLoaded && this.state.PdfFrameLoaded == false) {
        return false;
      }

      return true;
    }

    handleNewReceiveDetails = (nextProps, newInventory) => {
      const inventories = newInventory ? this.state.inventories.rows : [...nextProps.currentReceiveDetail.Purchase_Order_Line];
      inventories.map((inventory, index) => {
        inventory.ProductName = inventory.Product_id.Name;
        inventory.ProductNum = inventory.Product_id.ProductNum;
        inventory.ProductDescription = inventory.Product_id.Description;
        if (isHMM && inventory.package_size.split('SFT').length > 1) {
          inventory.RcvUnitPrice = inventory.FOBUnitPrice * Number(inventory.package_size.split('SFT')[0]);
        } else {
          inventory.RcvUnitPrice = inventory.FOBUnitPrice;
        }
        inventory.RcvUnitPrice2 = inventory.FOBUnitPrice;
        inventory.RcvQuantity = 0;
        inventory.WarehouseZone_id = inventory.Product_id.Default_WarehouseZone_id;
        inventory.Default_WarehouseFromBin_id = inventory.Product_id.Default_WarehouseFromBin_id;
        inventory.Default_WarehouseToBin_id = inventory.Product_id.Default_WarehouseToBin_id;
        inventory.StorageRate = 0;
        inventory.subWeights = [];
        inventory.RtnQuantity = 0;
        inventory.RefNum = inventory.Product_id.RefNum;
        inventory.uniqID = index;
        if (inventory.Product_id.UnitPerPallet) {
          const n = parseInt(inventory.Quantity / inventory.Product_id.UnitPerPallet);
          if (inventory.Quantity % inventory.Product_id.UnitPerPallet) { inventory.Pallet = n + 1; } else { inventory.Pallet = n; }
          if (!inventory.Pallet) { inventory.Pallet = 0; }
        } else {
          inventory.Pallet = 0;
        }
      });

      const receivedInventories = [...nextProps.currentReceiveDetail.Warehouse_Receive_Line];
      receivedInventories.map((inventory, index) => {
        inventory.ProductName = inventory.Product_id.Name;
        inventory.ProductNum = inventory.Product_id.ProductNum;
        inventory.ProductDescription = inventory.Product_id.Description;
        if (isHMM && inventory.package_size.split('SFT').length > 1) {
          inventory.RcvUnitPrice = inventory.FOBUnitPrice * Number(inventory.package_size.split('SFT')[0]);
        } else {
          inventory.RcvUnitPrice = inventory.FOBUnitPrice;
        }
        if (inventory.Product_id.ProductType === 'Fixed') {
          if(isGGI || isOLG) {
            inventory.RcvTotalPrice = parseFloat(inventory.ReceivedQuantity * inventory.RcvUnitPrice).toFixed(2);
          } else {
            inventory.RcvTotalPrice = parseFloat(inventory.InStock * inventory.RcvUnitPrice).toFixed(2);
          }
        } else {
          if(isGGI) {
            inventory.RcvTotalPrice = parseFloat(inventory.RcvTotalWeight * inventory.small_unit_price).toFixed(2);
          } else {
            inventory.RcvTotalPrice = parseFloat(inventory.RcvTotalWeight * inventory.RcvUnitPrice).toFixed(2);
          }
        }
        inventory.RcvUnitPrice2 = inventory.FOBUnitPrice;
        inventory.RcvQuantity = 0;
        inventory.WarehouseZone_id = inventory.Product_id.Default_WarehouseZone_id;
        inventory.Default_WarehouseFromBin_id = inventory.Product_id.Default_WarehouseFromBin_id;
        inventory.Default_WarehouseToBin_id = inventory.Product_id.Default_WarehouseToBin_id;
        inventory.StorageRate = 0;
        inventory.subWeights = [];
        inventory.RtnQuantity = 0;
        // inventory.RcvTotalWeight = 0;
        inventory.RefNum = inventory.Product_id.RefNum;
        inventory.uniqID = index;
        if (inventory.Product_id.UnitPerPallet) {
          const n = parseInt(inventory.Quantity / inventory.Product_id.UnitPerPallet);
          if (inventory.Quantity % inventory.Product_id.UnitPerPallet) { inventory.Pallet = n + 1; } else { inventory.Pallet = n; }
          if (!inventory.Pallet) { inventory.Pallet = 0; }
        } else {
          inventory.Pallet = 0;
        }
      });

      const newInventories = { ...this.state.inventories, rows: inventories.sort(sortByLineID) };
      const newReceivedInventories = { ...this.state.receivedInventories, rows: receivedInventories};

      if (nextProps.currentReceive) {
        const curReceive = nextProps.currentReceive;
        // this.receiptNum = ;
        const warehouseName = curReceive.WarehouseName;
        // this.receiver = ;
        const PONum = curReceive.PONum;
        const purchaser = curReceive.Purchaser;

        const vendorNum = curReceive.VendorNum;
        const vendorName = curReceive.vendorName;
        const vendorDescription = curReceive.VendorDescription;
        // this.vendorAdd = ;
        // this.vendorContact = ;
        const orderDate = curReceive.OrderDate;
        const ETADate = curReceive.ETADate;

        this.setState({
          warehouseName,
          PONum,
          purchaser,
          vendorNum,
          vendorName,
          vendorDescription,
          orderDate,
          ETADate,
        });
      }
      this.setState({
        inventories: newInventories,
        receivedInventories: this.palletConvertInitial(newReceivedInventories),
      });

      if (nextProps.createTime) {
        this.setState({ createTime: nextProps.createTime });
      }
    }

    palletConvertInitial = (newReceivedInventories) => {
      const receivedInventories = {
        ...this.state.receivedInventories,
      };
      _.forEach(newReceivedInventories.rows, row => {
        const CalcoDispatchCase = row.Product_id.CalcoDispatchCase;
        const Quantity = row.Quantity;
        let lineQty;
        if (isOCM && CalcoDispatchCase) {
          lineQty = CalcoDispatchCase;
        } else {
          lineQty = Quantity;
        }
        const totalPallets = parseInt((Quantity / lineQty));
        const expire_date = row.expire_date ? `${row.expire_date.split('-')[1]}-${row.expire_date.split('-')[2]}-${row.expire_date.split('-')[0]}` : '';
        const lines = Array.from({ length: totalPallets }, (_, i) => ({
          ...row, RcvQuantity: 0,
          expire_datetime: expire_date,
          Quantity: lineQty,
          uniqID: receivedInventories.rows.length + i + 1,
          location: [row.Product_id.DefaultZone, row.Product_id.DefaultBin, row.Product_id.DefaultLevel].filter(ele => ele).join('-'),
        }));
        const reminder = Quantity - (lineQty * totalPallets);
        receivedInventories.rows = [...receivedInventories.rows, ...lines];
        if (reminder > 0) {
          receivedInventories.rows = [...receivedInventories.rows, {
            ...row, RcvQuantity: 0, expire_datetime: expire_date, Quantity: reminder, uniqID: receivedInventories.rows.length + 1, location: [row.Product_id.DefaultZone, row.Product_id.DefaultBin, row.Product_id.DefaultLevel].filter(ele => ele).join('-')
          }];
        }
      });
      return receivedInventories;
    }

    handleResize(e) {
      this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.twoLineButton - 50 });
    }

    openConfirm() { this.setState({ confirmOpen: true }); }

    closeConfirm() { this.setState({ confirmOpen: false }); }

    printReceive = () => {
      const { createdReceive } = this.props;
      this.props.printWarehouseReceive(createdReceive.WarehouseReceiveNum);
    }

    closeSetWeight() {
      this.setState({ setWeightOpen: false });
    }

    openSetWeight() {
      this.setState({ setWeightOpen: true });
    }

    showSaveConfirm() {
      this.setState({
        saveConfirmOpen: true,
        SyncAp: false,
      });
    }

    showSaveConfirmAP() {
      this.setState({
        saveConfirmOpen: true,
        SyncAp: true,
      });
    }

    closeSaveConfirm() {
      this.setState({
        saveConfirmOpen: false,
      });
    }

    // setInventoryToReceive(e) {
    //     e.preventDefault();
    //     const { inventories, receivedInventories } = this.state;
    //     const inventoryToReceive = { ...inventories.selectedRows[0],
    //         ToZone: this.props.toZoneValue,
    //         ToBin: this.props.toBinValue,
    //         RcvQuantity: this.props.rcvQuantityValue,
    //         RcvUnitPrice: this.props.rcvUnitPriceValue,
    //         RcvTotalPrice: this.props.rcvTotalPriceValue,
    //         Pallet: this.props.palletValue,
    //         StorageRate: this.props.storageRateValue,
    //         RtnQuantity: this.props.rtnQuantityValue
    //     };
    //
    //     const newReceivedInventories = { ...receivedInventories };
    //     const newInventories = { ...inventories };
    //     newReceivedInventories.rows.push(inventoryToReceive)
    //
    //     const index = _.findIndex(inventories.rows, { 'Product_id': inventories.selectedRows[0].PurchaseOrderLine_id });
    //     if (index > -1) {
    //         newInventories.rows.splice(index, 1);
    //     }
    //     newInventories.selectedRows = [];
    //     this.setState({
    //         receivedInventories: newReceivedInventories,
    //         inventories: newInventories
    //     })
    // }
    //
    // cancelReceive(e) {
    //     e.preventDefault();
    //     const { inventories, receivedInventories } = this.state;
    //     const inventoryToCancel = { ...receivedInventories.selectedRows[0] };
    //
    //     const newReceivedInventories = { ...receivedInventories };
    //     const newInventories = { ...inventories };
    //     newInventories.rows.push(inventoryToCancel)
    //
    //     const index = _.findIndex(receivedInventories.rows, { 'Product_id': receivedInventories.selectedRows[0].PurchaseOrderLine_id });
    //     if (index > -1) {
    //         newReceivedInventories.rows.splice(index, 1);
    //     }
    //     newReceivedInventories.selectedRows = [];
    //     this.setState({
    //         receivedInventories: newReceivedInventories,
    //         inventories: newInventories
    //     })
    // }

    autoLoad = () => {
      if (!isHO && !isVAK && !isJRC) {
        this.palletConvert();
        return;
      }
      const inventories = { ...this.state.inventories };
      const receivedInventories = { ...this.state.receivedInventories };
      inventories.rows = inventories.rows.map((r) => {
        r.isSelected = false;
        if (r.Product_id.ProductType === 'Fixed') {
          r.RcvQuantity = r.Quantity;
          // r.RcvTotalWeight = ((parseFloat(r.RcvQuantity) || 0)*(parseFloat(r.Product_id.NetWeight) || 0)).toFixed(2)
          r.RcvTotalWeight = +((parseFloat(r.RcvQuantity) || 0) * (parseFloat(r.Product_id.NetWeight) || 0)).toFixed(2);
          r.RcvTotalPrice = +((parseFloat(r.RcvQuantity) || 0) * (parseFloat(r.RcvUnitPrice) || 0)).toFixed(2);
          if (isABBLE) {
            r.RcvTotalWeight = +((parseFloat(r.RcvQuantity) || 0) * (parseFloat(r.Product_id.NetWeight) || 0) * (r.purchase_convert_unit || 1)).toFixed(2);
            r.RcvTotalPrice = + ((parseFloat(r.RcvQuantity) || 0) * (parseFloat(r.RcvUnitPrice) || 0) * (r.purchase_convert_unit || 1)).toFixed(2);
          }
          receivedInventories.rows.push(r);
          return null;
        } else if (r.Product_id.ProductType === 'Per-Pound') {
          r.RcvQuantity = r.Quantity;
          // r.RcvTotalWeight = ((parseFloat(r.RcvQuantity) || 0)*(parseFloat(r.Product_id.NetWeight) || 0)).toFixed(2)
          r.RcvTotalWeight = +((parseFloat(r.RcvQuantity) || 0) * (parseFloat(r.Product_id.NetWeight) || 0)).toFixed(2);
          r.RcvTotalPrice = +(r.RcvTotalWeight * (parseFloat(r.RcvUnitPrice) || 0)).toFixed(2);
          if (isABBLE) {
            r.RcvTotalWeight = +((parseFloat(r.RcvQuantity) || 0) * (parseFloat(r.Product_id.NetWeight) || 0) * (r.purchase_convert_unit || 1)).toFixed(2);
            r.RcvTotalPrice = +(r.RcvTotalWeight * (parseFloat(r.RcvUnitPrice) || 0)).toFixed(2);
          }
          if (isGGI) {
            r.RcvTotalPrice = +((parseFloat(r.RcvQuantity) || 0) * (parseFloat(r.RcvUnitPrice) || 0).toFixed(2));
          }
          receivedInventories.rows.push(r);
          return null;
        } else if (r.Product_id.ProductType === 'Non-Fixed') {
          if (isVAK) {
            r.RcvQuantity = r.Quantity;
            r.RcvTotalWeight = r.TotalNetWeight;
            r.RcvTotalPrice = ((parseFloat(r.TotalNetWeight) || 0) * (parseFloat(r.RcvUnitPrice) || 0)).toFixed(2);
            receivedInventories.rows.push(r);
            return null;
          }
        }
        return r;
      });
      inventories.rows = inventories.rows.filter(obj => obj !== null);
      let totalPrice = 0;
      receivedInventories.rows.map((r) => {
        totalPrice += parseFloat(Math.round((parseFloat(r.RcvTotalPrice) || 0) * 100) / 100);
      });
      // totalPrice = parseFloat(Math.round(totalPrice * 100) / 100).toFixed(2);
      totalPrice = +parseFloat(totalPrice).toFixed(2);
      receivedInventories.rows.sort(sortByLineID);
      this.setState({ receivedInventories, inventories, totalPrice });
    }

    palletConvert = () => {
      const inventories = { ...this.state.inventories };
      const receivedInventories = { ...this.state.receivedInventories };
      inventories.rows = _.map(inventories.rows, row => {
        if (row.Product_id.ProductType !== 'Non-Fixed') {
          const CalcoDispatchCase = row.Product_id.CalcoDispatchCase;
          const NetWeight = row.Product_id.NetWeight;
          const Quantity = row.Quantity;
          const RcvUnitPrice = row.RcvUnitPrice;
          let lineQty;
          if (isOCM && CalcoDispatchCase && Quantity >= CalcoDispatchCase) {
            lineQty = CalcoDispatchCase;
          } else {
            lineQty = Quantity;
          }
          let totalPallets = parseInt((Quantity / lineQty));
          const expire_date = row.expire_date ? `${row.expire_date.split('-')[1]}-${row.expire_date.split('-')[2]}-${row.expire_date.split('-')[0]}` : '';
          let lines = [];
          lines = Array.from({ length: totalPallets }, (_, i) => {
            let RcvTotalPrice, RcvTotalWeight, subWeights = [], TotalNetWeight;
            if (row.Product_id.ProductType === 'Fixed' || (isABBLE && (row.Product_id.ProductType === 'Non-Product' || row.Product_id.ProductType === 'Service'))) {
              RcvTotalPrice = ((parseFloat(lineQty) || 0) * (parseFloat(RcvUnitPrice) || 0)).toFixed(2);
              RcvTotalWeight = ((parseFloat(lineQty) || 0) * (parseFloat(NetWeight) || 0)).toFixed(2);
              if (isSH) {
                RcvTotalWeight = parseInt(((parseFloat(lineQty) || 0) * (parseFloat(NetWeight) || 0)).toFixed(2));
              }
              if (isABBLE) {
                RcvTotalWeight = ((parseFloat(lineQty) || 0) * (parseFloat(NetWeight) || 0) * (row.purchase_convert_unit || 1)).toFixed(2);
                RcvTotalPrice = ((parseFloat(lineQty) || 0) * (parseFloat(RcvUnitPrice) || 0) * (row.purchase_convert_unit || 1)).toFixed(2);
              }
              TotalNetWeight = parseInt(RcvTotalWeight);
            } else {
              if(isGGI) {
                RcvTotalPrice = ((parseFloat(lineQty) || 0) * (parseFloat(NetWeight) || 0) * (parseFloat(row.small_unit_price) || 0)).toFixed(2);
              } else {
                RcvTotalPrice = ((parseFloat(lineQty) || 0) * (parseFloat(NetWeight) || 0) * (parseFloat(RcvUnitPrice) || 0)).toFixed(2);
              }
              RcvTotalWeight = ((parseFloat(lineQty) || 0) * (parseFloat(NetWeight) || 0)).toFixed(2);
              if (isSH) {
                RcvTotalWeight = parseInt(((parseFloat(lineQty) || 0) * (parseFloat(NetWeight) || 0)).toFixed(2));
              }
              if (isABBLE) {
                RcvTotalWeight = ((parseFloat(lineQty) || 0) * (parseFloat(NetWeight) || 0) * (row.purchase_convert_unit || 1)).toFixed(2);
                RcvTotalPrice = (RcvTotalWeight * (parseFloat(RcvUnitPrice) || 0)).toFixed(2);
              }
              subWeights = Array.from({ length: lineQty }, () => ({ Weight: NetWeight })),
              TotalNetWeight = parseInt(RcvTotalWeight);
            }
            return {
              ...row,
              RcvQuantity: lineQty,
              expire_datetime: expire_date,
              Quantity: lineQty,
              uniqID: receivedInventories.rows.length + i + 1,
              location: (isSV || isSH) ? 'DZ' : isOLG ? row.Location : [row.Product_id.DefaultZone, row.Product_id.DefaultBin, row.Product_id.DefaultLevel].filter(ele => ele).join('-'),
              RcvTotalPrice,
              RcvTotalWeight,
              subWeights,
              TotalNetWeight,
            }
          });
          const residual = Quantity - (lineQty * totalPallets);
          receivedInventories.rows = [...receivedInventories.rows, ...lines];
          if (residual > 0) {
            let RcvTotalPrice, RcvTotalWeight, subWeights = [], TotalNetWeight;
            if (row.Product_id.ProductType === 'Fixed' || (isABBLE && (row.Product_id.ProductType === 'Non-Product' || row.Product_id.ProductType === 'Service'))) {
              RcvTotalPrice = ((parseFloat(residual) || 0) * (parseFloat(RcvUnitPrice) || 0)).toFixed(2);
              RcvTotalWeight = ((parseFloat(residual) || 0) * (parseFloat(NetWeight) || 0)).toFixed(2);
              if (isSH) {
                RcvTotalWeight = parseInt(((parseFloat(residual) || 0) * (parseFloat(NetWeight) || 0)).toFixed(2));
              }
              if (isABBLE) {
                RcvTotalWeight = ((parseFloat(residual) || 0) * (parseFloat(NetWeight) || 0) * (row.purchase_convert_unit || 1)).toFixed(2);
                RcvTotalPrice = ((parseFloat(residual) || 0) * (parseFloat(RcvUnitPrice) || 0) * (row.purchase_convert_unit || 1)).toFixed(2);
              }
              TotalNetWeight = parseInt(RcvTotalWeight);
            } else {
              if(isGGI) {
                RcvTotalPrice = ((parseFloat(residual) || 0) * (parseFloat(NetWeight) || 0) * (parseFloat(row.small_unit_price) || 0)).toFixed(2);
              } else {
                RcvTotalPrice = ((parseFloat(residual) || 0) * (parseFloat(NetWeight) || 0) * (parseFloat(RcvUnitPrice) || 0)).toFixed(2);
              }
              RcvTotalWeight = ((parseFloat(residual) || 0) * (parseFloat(NetWeight) || 0)).toFixed(2);
              if (isSH) {
                RcvTotalWeight = parseInt(((parseFloat(residual) || 0) * (parseFloat(NetWeight) || 0)).toFixed(2));
              }
              if (isABBLE) {
                RcvTotalWeight = ((parseFloat(residual) || 0) * (parseFloat(NetWeight) || 0) * (row.purchase_convert_unit || 1)).toFixed(2);
                RcvTotalPrice = (RcvTotalWeight * (parseFloat(RcvUnitPrice) || 0)).toFixed(2);
              }
              subWeights = Array.from({ length: residual }, () => ({ Weight: NetWeight })),
              TotalNetWeight = parseInt(RcvTotalWeight);
            }
            receivedInventories.rows = [...receivedInventories.rows, {
              ...row,
              RcvQuantity: residual,
              expire_datetime: expire_date,
              Quantity: residual,
              RcvTotalPrice,
              RcvTotalWeight,
              subWeights,
              TotalNetWeight,
              uniqID: receivedInventories.rows.length + 1, location: [row.Product_id.DefaultZone, row.Product_id.DefaultBin, row.Product_id.DefaultLevel].filter(ele => ele).join('-')
            }];
          }
          return null;
        }
        return row;
      });
      receivedInventories.rows = receivedInventories.rows.sort(sortByLineID)
      inventories.rows = inventories.rows.filter(obj => obj !== null);
      this.setState({
        inventories,
        receivedInventories,
      })
    }

    manualLoad = () => {
      let inventories = { ...this.state.inventories };
      let receivedInventories = { ...this.state.receivedInventories };

      const receivedInventoriesRows = [...receivedInventories.rows];
      const selectedInventoriesRows = [...inventories.selectedRows];
      const inventoriesRows = [...inventories.rows];

      selectedInventoriesRows.map((row) => {
        row.isSelected = false;
        if (isOLG) {
          row.location = row.Location;
        }
        if (isSV || isSH) {
          row.location = 'DZ';
        }
        if (row.Product_id.ProductType === 'Fixed') {
          row.RcvTotalPrice = ((parseFloat(row.RcvQuantity) || 0) * (parseFloat(row.RcvUnitPrice) || 0)).toFixed(2);
          row.RcvTotalWeight = ((parseFloat(row.RcvQuantity) || 0) * (parseFloat(row.Product_id.NetWeight) || 0)).toFixed(2);
          if (isABBLE) {
            row.RcvTotalPrice = ((parseFloat(row.RcvQuantity) || 0) * (parseFloat(row.RcvUnitPrice) || 0) * (row.purchase_convert_unit || 1)).toFixed(2);
            row.RcvTotalWeight = ((parseFloat(row.RcvQuantity) || 0) * (parseFloat(row.Product_id.NetWeight) || 0) * (row.purchase_convert_unit || 1)).toFixed(2);
          }
          row.uniqID = receivedInventoriesRows.length + 1;
          receivedInventoriesRows.push(row);
          const index = _.findIndex(inventoriesRows, { ProductNum: row.ProductNum });
          if (index > -1) {
            inventoriesRows.splice(index, 1);
          }
        } else if (row.Product_id.ProductType === 'Per-Pound') {
          row.RcvTotalPrice = ((parseFloat(row.RcvQuantity) || 0) * (parseFloat(row.Product_id.NetWeight) || 0) * (parseFloat(row.RcvUnitPrice) || 0)).toFixed(2);
          row.RcvTotalWeight = ((parseFloat(row.RcvQuantity) || 0) * (parseFloat(row.Product_id.NetWeight) || 0)).toFixed(2);
          if (isABBLE) {
            row.RcvTotalWeight = ((parseFloat(row.RcvQuantity) || 0) * (parseFloat(row.Product_id.NetWeight) || 0)).toFixed(2) * row.purchase_convert_unit;
            row.RcvTotalPrice = (row.RcvTotalWeight * (parseFloat(row.RcvUnitPrice) || 0)).toFixed(2)
          }
          if (isGGI) {
            row.RcvTotalPrice = ((parseFloat(row.RcvQuantity) || 0) * (parseFloat(row.Product_id.NetWeight) || 0) * (parseFloat(row.small_unit_price) || 0)).toFixed(2);
          }
          row.uniqID = receivedInventoriesRows.length + 1;
          receivedInventoriesRows.push(row);
          const index = _.findIndex(inventoriesRows, { ProductNum: row.ProductNum });
          if (index > -1) {
            inventoriesRows.splice(index, 1);
          }
        } else if (isVAK && row.Product_id.ProductType === 'Non-Fixed') {
          row.RcvTotalPrice = ((parseFloat(row.TotalNetWeight) || 0) * (parseFloat(row.RcvUnitPrice) || 0)).toFixed(2);
          row.RcvTotalWeight = (parseFloat(row.TotalNetWeight) || 0).toFixed(2);
          row.uniqID = receivedInventoriesRows.length + 1;
          receivedInventoriesRows.push(row);
          const index = _.findIndex(inventoriesRows, { ProductNum: row.ProductNum });
          if (index > -1) {
            inventoriesRows.splice(index, 1);
          }
        }
      });

      receivedInventories = { ...receivedInventories, rows: receivedInventoriesRows.sort(sortByLineID) };
      inventories = { ...inventories, rows: inventoriesRows, selectedRows: [] };

      let totalPrice = 0;
      receivedInventories.rows.map((r) => {
        totalPrice += parseFloat(Math.round((parseFloat(r.RcvTotalPrice) || 0) * 100) / 100);
      });
      // totalPrice = parseFloat(Math.round(totalPrice * 100) / 100).toFixed(2);
      totalPrice = parseFloat(totalPrice).toFixed(2);
      this.setState({ receivedInventories, inventories, totalPrice });
    }

    unload(type) {
      const { inventories } = this.state;
      const { receivedInventories } = this.state;
      // left and right table rows
      const inventoriesRows = inventories.rows;
      let receivedInventoriesRows = receivedInventories.rows;
      // right table selected rows
      let pushbackRows = [];
      if (type === 'selection') {
        pushbackRows = receivedInventories.selectedRows;
      } else if (type === 'all') {
        pushbackRows = receivedInventories.rows;
      }
      // products have not been received should reset back to the inventories table
      // reset selected rows values
      receivedInventoriesRows.map((row) => {
        row.isSelected = false;
        _.filter(
          pushbackRows,
          (r) => {
            if (r.Product_id.Product_id === row.Product_id.Product_id) {
              row.RcvQuantity = 0;
              row.RcvTotalWeight = 0;
              row.subWeights = [];
              row.location = null;
            }
            return true;
          },
        );
      });

      // reset pushback rows values and filter out products that have not previously received
      pushbackRows = pushbackRows.filter((row) => {
        row.RcvQuantity = 0;
        row.RcvTotalWeight = 0;
        row.subWeights = [];
        return row.ReceivedQuantity === 0;
      });

      // delete pushback rows from received inventories rows
      pushbackRows.map((row) => {
        receivedInventoriesRows = _.filter(
          receivedInventoriesRows,
          r => r.Product_id.Product_id !== row.Product_id.Product_id,
        );
      });

      inventoriesRows.map((row) => {
        row.isSelected = false;
        row.RcvQuantity = 0;
        row.RcvTotalWeight = 0;
        row.subWeights = [];
      });

      this.setState({
        receivedInventories: {
          ...inventories,
          rows: receivedInventoriesRows,
          selectedRows: [],
        },
        inventories: {
          ...receivedInventories,
          rows: [...inventoriesRows, ...pushbackRows].sort(sortByLineID),
          selectedRows: [],
        },
      });
    }

  selectInventoryInfo = (selectedInventoryRow) => {
    this.setState({ ProductNum: selectedInventoryRow });
  }

  handleOptionChange = (changeEvent) => {
    this.setState({ productSearchType: changeEvent.target.value });
  }

  handleProductSelect = (product, suggestion, e) => {
    let Product_id = {
      CRV: suggestion.CRV,
      Description: suggestion.Description,
      IsTaxable: suggestion.IsTaxable,
      Name: suggestion.Name,
      NetWeight: suggestion.NetWeight,
      ProductNum: suggestion.ProductNum,
      ProductType: suggestion.ProductType,
      Product_id: suggestion.Product_id,
      RefNum: suggestion.RefNum,
      WeightRange: {MaxWeigh: 0, MinWight: 0},
    }
    suggestion.Product_id = Product_id
    this.setState({
      selectedProduct: {
        ...this.state.selectedProduct,
        product: suggestion,
        UnitPrice: suggestion.RefPrice
      }
    }, () => {
      let tabindex = $(e).attr("tabindex") || 0;
      tabindex = Number(tabindex);
      tabindex += 1;
      const elem = $("[tabindex=" + tabindex + "]");
      if (elem[0]) {
        elem.focus();
      }
    })
  }


  autoTab = e => {
    let tabindex = $(e.target).attr("tabindex") || 0;
    tabindex = Number(tabindex);
     if (e.key === 'Enter') {
      tabindex += 1;
    }
    const elem = $("[tabindex=" + tabindex + "]");
    if (elem[0]) {
      elem.focus();
    }
  };

  configureQuantity = (e) => {
    this.setState({
      selectedProduct: {
        ...this.state.selectedProduct,
          Quantity: e.target.value
      }});
  }

  configureUnitPrice = (e) => {
    this.setState({
      selectedProduct: {
        ...this.state.selectedProduct,
        UnitPrice: e.target.value
      }
    })
  }

  addProductCB = () => {
    let array = this.state.inventories.rows.concat(this.state.selectedProduct.product)
    this.setState({
      inventories: {
        ...this.state.inventories,
        rows: array
      }
    }, () => {
      this.handleNewReceiveDetails(this.props, true)
    });
  }

  addProduct = (e) => {
    if (e.key === 'Enter') {
      this.setState({
        selectedProduct: {
          ...this.state.selectedProduct,
          newProductAdded: true,
          product: {
            ...this.state.selectedProduct.product,
            Quantity: this.state.selectedProduct.Quantity,
            FOBUnitPrice: this.state.selectedProduct.UnitPrice,
          }
        }
      }, () => {
        this.addProductCB()
      })
    }
  }

    renderAutoSuggest() {
      if (!this.state.filteredByItem) {
        return (
          <div className="control-dropdown">
            <Row>
              <Col xs={3}>
                <GenericProductSuggest
                  value={this.state.suggestValue}
                  onChange={(e, { newValue }) => { this.setState({ suggestValue: newValue }); }}
                  SearchType={this.state.productSearchType}
                  fetchOrdersByProduct={this.handleProductSelect}
                  setProductNum={this.selectInventoryInfo}
                  tabIndex={0}
                  />
                </Col>
              <Col xs={2}>
                <Col xs={6}><Translate value="unit_price" />:</Col>
              <Col xs={6}>
                <input
                  tabIndex={1}
                  value={this.state.selectedProduct.UnitPrice}
                  onKeyPress={(e) => this.autoTab(e)}
                  onChange={(e) => this.configureUnitPrice(e)}
                  type="text"
                  style={inputStyle}
                  placeholder="Quantity"
                >
                </input>
                  </Col>
              </Col>
              <Col xs={2}>
                <Col xs={6}>Quantity:</Col>
                <Col xs={6}>
                  <input
                    tabIndex={2}
                    value={this.state.selectedProduct.Quantity}
                    onKeyPress={(e) => this.addProduct(e)}
                    onChange={(e) => this.configureQuantity(e)}
                    type="text"
                    style={inputStyle}
                    placeholder="Quantity"
                  ></input>
                </Col>
              </Col>
              </Row>
          </div>
        );
      }
      return (
        <div id="suggestion-box">
          {this.state.suggestValue}
          <em
            className="fa fa-times pull-right"
            onClick={() => {
              this.setState({
                filteredByItem: false,
                suggestValue: '',
              });
            }}
          />
          <input style={{paddingLeft: '700px'}} type="text" placeholder="wtf2"></input>
        </div>
      );
    }

    renderReceiveTotalWeightName = () => {
      if (isSH) return <Translate value="total_pcs" />;
      return <Translate value="receive_total_wt" />;
    }

    //--------------------------------------------------LocationSelectionModal
    setLocationSelectModalVisibility = (isLocationSelectModalVisible = false) => this.setState({ isLocationSelectModalVisible });
    handleLocationSelect = (location) => {
      const newLine = {
        ...this.state.editingLine,
        ...location,
      };
      const rows = [...this.state.receivedInventories.rows];
      const editingIndex = _.findIndex(rows, { uniqID: newLine.uniqID});
      rows[editingIndex] = newLine;
      this.setState({
        receivedInventories: {
          ...this.state.receivedInventories,
          rows,
        }
      });
      this.setLocationSelectModalVisibility();
    }

    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
    renderTable() {
      if (this.props.inventoriesIsLoading && !this.props.vendorError) return <Spinner />;
      else if (this.props.inventoriesError) return <ContentWrapper><div className="alert alert-danger">{this.props.inventoriesError}</div></ContentWrapper>;


      const productNameHash = {};
      const productNumHash = {};

      // Parameters of the react-data-grid

      const getRows = () => Data.Selectors.getRows(this.state.inventories);

      const getSize = () => getRows().length;

      const rowGetter = (rowIdx) => {
        const rows = getRows();
        return Object.assign({}, rows[rowIdx]);
      };

      // Handle the sortable function

      const handleGridSort = (sortColumn, sortDirection) => {
        const inventories = { ...this.state.inventories, sortColumn, sortDirection };
        this.setState({ inventories });
      };

      const handleFilterChange = (filter) => {
        const newFilters = Object.assign({}, this.state.inventories.filters);
        if (filter.filterTerm) {
          newFilters[filter.column.key] = filter;
        } else {
          delete newFilters[filter.column.key];
        }
        const inventories = { ...this.state.inventories, filters: newFilters };
        this.setState({ inventories });
      };

      const handleRowUpdated = (e) => {
        // merge updated row with current row and rerender by setting state
        const { inventories } = this.state;
        const rows = inventories.rows.slice(0);
        if (e.updated.RcvQuantity != null) {
          if (rows[e.rowIdx].Product_id.ProductType === 'Non-Fixed') {
            let oldQty = rows[e.rowIdx].RcvQuantity;
            // Object.assign(rows[e.rowIdx], e.updated);
            this.setState({ totalLoaded: e.updated.RcvQuantity, rowChosen: e.rowIdx, tableChosen: 'inventories', oldQty });
            if (isVAK) {
              Object.assign(rows[e.rowIdx], { RcvTotalPrice: +roundTo((parseFloat(e.updated.RcvQuantity) || 0) * (parseFloat(rows[e.rowIdx].Product_id.NetWeight) || 0) * (parseFloat(rows[e.rowIdx].RcvUnitPrice) || 0), 2).toFixed(2) });
              Object.assign(rows[e.rowIdx], { RcvTotalWeight: +roundTo((parseFloat(e.updated.RcvQuantity) || 0) * (parseFloat(rows[e.rowIdx].Product_id.NetWeight) || 0), 2).toFixed(2) });
              Object.assign(rows[e.rowIdx], e.updated);
            } else {
              this.openSetWeight();
            }
          } else if (rows[e.rowIdx].Product_id.ProductType === 'Fixed') {
            Object.assign(rows[e.rowIdx], { RcvTotalPrice: +roundTo((parseFloat(e.updated.RcvQuantity) || 0) * (parseFloat(rows[e.rowIdx].RcvUnitPrice) || 0), 2).toFixed(2) });
            Object.assign(rows[e.rowIdx], e.updated);
          } else {
            if(isGGI) {
              Object.assign(rows[e.rowIdx], { RcvTotalPrice: +roundTo((parseFloat(e.updated.RcvQuantity) || 0) * (parseFloat(rows[e.rowIdx].Product_id.NetWeight) || 0) * (parseFloat(rows[e.rowIdx].small_unit_price) || 0), 2).toFixed(2) });
            } else {
              Object.assign(rows[e.rowIdx], { RcvTotalPrice: +roundTo((parseFloat(e.updated.RcvQuantity) || 0) * (parseFloat(rows[e.rowIdx].Product_id.NetWeight) || 0) * (parseFloat(rows[e.rowIdx].RcvUnitPrice) || 0), 2).toFixed(2) });
            }
            Object.assign(rows[e.rowIdx], e.updated);
          }
        } else if (e.updated.RcvUnitPrice != null) {
          if (rows[e.rowIdx].Product_id.ProductType == 'Non-Fixed' || rows[e.rowIdx].Product_id.ProductType === 'Per-Pound') {
            Object.assign(rows[e.rowIdx], { RcvTotalPrice: +roundTo((parseFloat(e.updated.RcvUnitPrice) || 0) * (parseFloat(rows[e.rowIdx].RcvTotalWeight) || 0), 2).toFixed(2) });
          } else {
            Object.assign(rows[e.rowIdx], { RcvTotalPrice: +roundTo((parseFloat(e.updated.RcvUnitPrice) || 0) * (parseFloat(rows[e.rowIdx].RcvQuantity) || 0), 2).toFixed(2) });
          }
          Object.assign(rows[e.rowIdx], e.updated);
        }

        // if(e.cellKey == 'RcvQuantity') {
        //   Object.assign(rows[e.rowIdx], e.updated);
        //   // totalLoaded: null,
        //   // rowChosen: null,
        // }
        else if (e.updated.RcvTotalWeight != null) {
          if (rows[e.rowIdx].Product_id.ProductType === 'Non-Fixed' || rows[e.rowIdx].Product_id.ProductType === 'Per-Pound') {
            Object.assign(rows[e.rowIdx], { RcvTotalPrice: +roundTo((parseFloat(e.updated.RcvTotalWeight) || 0) * (parseFloat(rows[e.rowIdx].RcvUnitPrice) || 0), 2).toFixed(2) });
            if(isGGI) {
              if(rows[e.rowIdx].Product_id.ProductType === 'Non-Fixed') {
                Object.assign(rows[e.rowIdx], { RcvTotalPrice: +roundTo((parseFloat(e.updated.RcvTotalWeight) || 0) * (parseFloat(rows[e.rowIdx].small_unit_price) || 0), 2).toFixed(2) });
                Object.assign(rows[e.rowIdx], { RcvUnitPrice: +roundTo((parseFloat(e.updated.RcvTotalWeight / rows[e.rowIdx].RcvQuantity) || 0) * (parseFloat(rows[e.rowIdx].small_unit_price) || 0), 2).toFixed(2)});
              }
            }
            if (isVAK) {
              Object.assign(rows[e.rowIdx], {RcvQuantity: parseFloat(e.updated.RcvTotalWeight / rows[e.rowIdx].Product_id.NetWeight)});
            }
            if(isLAP) {
                let length = rows[e.rowIdx].RcvQuantity;
                let avgWeight = (parseFloat(e.updated.RcvTotalWeight || 0)) / (parseFloat(length) || 1);
                avgWeight = (Math.floor(avgWeight * 100) / 100).toFixed(2);
                const diff = (parseFloat(e.updated.RcvTotalWeight || 0)) - (avgWeight * length);
                let cpWeights = [];
                for(let i=0; i < length; i++) {
                  if(i != length-1) {
                    cpWeights.push({Weight:avgWeight});
                  } else {
                    cpWeights.push({Weight:((parseFloat(avgWeight || 0) + diff) || 0).toFixed(2)});
                  }
                }
                rows[e.rowIdx].subWeights = cpWeights;
            }
            Object.assign(rows[e.rowIdx], e.updated);
          }
        } else {
          Object.assign(rows[e.rowIdx], e.updated);
        }
        let totalPrice = 0;
        rows.map((r) => {
          totalPrice += parseFloat(Math.round((parseFloat(r.RcvTotalPrice) || 0) * 100) / 100);
        });
        // totalPrice = parseFloat(Math.round(totalPrice * 100) / 100).toFixed(2);
        totalPrice = parseFloat(totalPrice).toFixed(2);

        /* update selectedRows if there's anything changed on the rows */
        const { selectedRows } = inventories;
        selectedRows.map((row) => {
          _.filter(
            rows,
            (r) => {
              if (r.PurchaseOrderLine_id === row.PurchaseOrderLine_id) {
                const index = _.findIndex(selectedRows, { PurchaseOrderLine_id: row.PurchaseOrderLine_id });
                selectedRows.splice(index, 1, r);
              }
              return true;
            },
          );
        });
        /* End of update selectedRows */

        const newInventories = { ...inventories, rows, selectedRows };
        this.setState({
          inventories: newInventories,
          totalPrice,
        });

        /*
          the following lines handle on quantity change to move to the right table,
          this solution does not update RcvTotalPrice,
          so disable it for now.
        */
        // if (rows[e.rowIdx].Product_id.ProductType !== 'Non-Fixed' && rows[e.rowIdx].Product_id.ProductType !== 'Per-Pound') {
        //   this.setRows(e.rowIdx, 'inventories', []);
        // }
      };

      // Handle the row select function

      const onRowSelect = (rows) => {
        const inventories = { ...this.state.inventories, selectedRows: rows };
        this.setState({ inventories });
      };

      const onRowsSelected = (rows) => {
        const newRows = getRows();
        const selectedRows = [...this.state.inventories.selectedRows];

        rows.map((r) => {
          newRows[r.rowIdx].isSelected = true;
          selectedRows.push(r.row);
        });
        const inventories = {
          ...this.state.inventories,
          rows: newRows,
          selectedRows,
        };
        this.setState({ inventories });
      };

      const onRowsDeselected = (rows) => {
        const newRows = [...this.state.inventories.rows];
        let selectedRows = [...this.state.inventories.selectedRows];
        rows.map((r) => {
          newRows[r.rowIdx].isSelected = false;
          selectedRows = _.filter(
            selectedRows,
            row => r.row.PurchaseOrderLine_id !== row.PurchaseOrderLine_id,
          );
          // const rowIndex = selectedRows.indexOf(r.row);
          // selectedRows.splice(rowIndex, 1);
        });
        const inventories = { ...this.state.inventories, rows: newRows, selectedRows };
        this.setState({ inventories });
      };

      // Custom Formatter component

      const NameFormatter = React.createClass({
        render() {
          if (this.props.value) return <span>{this.props.value.Name}</span>;
          return <span className="label label-danger">-</span>;
        },
      });

      const IsVariableFormatter = React.createClass({
        render() {
          const { dependentValues, value } = this.props;
          let quantity;
          if (dependentValues.ReceivedQuantity) {
            quantity = `${dependentValues.ReceivedQuantity}/${value}`;
          } else {
            quantity = `0/${value}`;
          }
          let type = '';
          if (dependentValues.Product_id.ProductType === 'Non-Fixed') {
            type = <label className="label label-success"><Translate value="non_fixed" /></label>;
          } else if (dependentValues.Product_id.ProductType === 'Per-Pound') {
            type = <label className="label label-primary"><Translate value="per_pound" /></label>;
          }
          return <span>{ quantity } { type }</span>;
        },
      });

      const EditableFormatter = React.createClass({
        render() {
          return <div id="editable-formatter">{this.props.value}</div>;
        },
      });
      // Column difinition

      const columns = [
        ...isOLG ? [] : [{
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 65,
          filterable: true,
        }],
        {
          key: 'ProductName',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: 200,
          filterable: true,
        },
        {
          key: 'RefNum',
          name: <Translate value={isOLG ? "item_no" : "ref_num"} />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'ProductDescription',
          name: <Translate value="desc" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
        },
        // {
        //     key: 'FOBUnitPrice',
        //     name: <Translate value="unit_dollarsign" />,
        //     resizable: true,
        //     sortable: true,
        //     width: 60,
        //     filterable: true
        // },
        {
          key: 'Quantity',
          name: <Translate value="qty" />,
          resizable: true,
          sortable: true,
          width: 60,
          filterable: true,
          formatter: IsVariableFormatter,
          getRowMetaData: row => row,
        },
        {
          key: 'RcvQuantity',
          name: <Translate value="rcv_qty" />,
          resizable: true,
          editable: true,
          sortable: true,
          width: 60,
          filterable: true,
          formatter: EditableFormatter,
        },
        {
          key: 'RcvTotalWeight',
          name: this.renderReceiveTotalWeightName(),
          resizable: true,
          editable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        // {
        //     key: 'RcvUnitPrice',
        //     name: <Translate value="receive_unit_dollarsign" />,
        //     resizable: true,
        //     editable: true,
        //     sortable: true,
        //     width: 80,
        //     filterable: true
        // },
        // {
        //     key: 'RcvTotalPrice',
        //     name: <Translate value="receive_total_dollarsign" />,
        //     resizable: true,
        //     sortable: true,
        //     width: 80,
        //     filterable: true
        // },
        // {
        //     key: 'RtnQuantity',
        //     name: <Translate value="return_qty" />,
        //     resizable: true,
        //     editable: true,
        //     sortable: true,
        //     width: 80,
        //     filterable: true
        // },
        // {
        //     key: 'InStock',
        //     name: <Translate value="instock" />,
        //     resizable: true,
        //     sortable: true,
        //     width: 80,
        //     filterable: true
        // },
        {
          key: 'Remark',
          name: <Translate value="remark" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        // {
        //     key: 'StorageRate',
        //     name: <Translate value="storage_rate" />,
        //     resizable: true,
        //     editable: true,
        //     sortable: true,
        //     width: 100,
        //     filterable: true
        // },
        {
          key: 'Pallet',
          name: <Translate value="pallet" />,
          resizable: true,
          editable: true,
          sortable: true,
          width: 60,
          filterable: true,
        },
      ];

      if (isUSPride) {
        const index1 = _.findIndex(columns, { key: "RcvTotalWeight" });
        columns.splice(index1, 1);
      }

      if (isGGI) {
        const expIdx = _.findIndex(columns, { key: "RcvTotalWeight" });
        const case_per_layer = {
          key: "case_per_layer",
          name: <Translate value="case_per_layer" />,
          resizable: true,
          width: 120,
          sortable: true,
          editable: true,
        };
        const layer_per_pallet = {
          key: "layer_per_pallet",
          name: <Translate value="layer_per_pallet" />,
          resizable: true,
          width: 120,
          sortable: true,
          editable: true,
        }
        columns.splice(expIdx, 0, case_per_layer, layer_per_pallet);
      }
      if (isVAK) {
        const rcvQtyIndex = columns.findIndex(column => column.key === 'RcvQuantity');
        if (rcvQtyIndex !== -1) {
          columns.splice(rcvQtyIndex, 0, {
            key: 'TotalNetWeight',
            name: <Translate value="total_wt" />,
            resizable: true,
            sortable: true,
            width: 60,
            filterable: true,
            formatter: IsVariableFormatter,
            getRowMetaData: row => row,
          });
        }
      }

      return (
        <Row>
          <Col sm={12}>
            <div style={{ maxWidth: '100%' }} id="ReceiveForm-dataGrid1">
              <ReactDataGrid
                rowKey="ProductNum"
                rowRenderer={<RowRenderer onDoubleClick={this.moveTo} />}
                enableCellSelect
                onGridSort={handleGridSort}
                columns={columns}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                rowHeight={25}
                headerRowHeight={45}
                minHeight={isCCW ? 576 : this.state.tableHeight}
                onRowUpdated={handleRowUpdated}
                enableRowSelect="multi"
                rowSelection={{
                  showCheckbox: true,
                  onRowsSelected,
                  onRowsDeselected,
                  selectBy: {
                    isSelectedKey: 'isSelected',
                  },
                }}
              />
            </div>
          </Col>
        </Row>
      );
    }
    renderReceivingTable() {
      if (this.props.inventoriesIsLoading && !this.props.vendorError) return <Spinner />;
      else if (this.props.inventoriesError) return <ContentWrapper><div className="alert alert-danger">{this.props.inventoriesError}</div></ContentWrapper>;

      const productNameHash = {};
      const productNumHash = {};

      // Parameters of the react-data-grid
      const getRows = () => Data.Selectors.getRows(this.state.receivedInventories);
      const getSize = () => getRows().length;

      const rowGetter = (rowIdx) => {
        const rows = getRows();
        return Object.assign({}, rows[rowIdx]);
      };

      // Handle the sortable function
      const handleGridSort = (sortColumn, sortDirection) => {
        const receivedInventories = { ...this.state.receivedInventories, sortColumn, sortDirection };
        this.setState({ receivedInventories });
      };

      

      const handleFilterChange = (filter) => {
        const newFilters = Object.assign({}, this.state.receivedInventories.filters);
        if (filter.filterTerm) {
          newFilters[filter.column.key] = filter;
        } else {
          delete newFilters[filter.column.key];
        }
        const receivedInventories = { ...this.state.receivedInventories, filters: newFilters };
        this.setState({ receivedInventories });
      };

      const handleRowUpdated = (e) => {
        // merge updated row with current row and rerender by setting state
        const { receivedInventories } = this.state;
        const rows = getRows();
        if (e.updated.RcvQuantity != null) {
          if (rows[e.rowIdx].Product_id.ProductType === 'Non-Fixed') {
            let oldQty = rows[e.rowIdx].RcvQuantity;
            // Object.assign(rows[e.rowIdx], e.updated);
            this.setState({ totalLoaded: e.updated.RcvQuantity, rowChosen: e.rowIdx, tableChosen: 'receivedInventories', oldQty });
            if (isVAK) {
              Object.assign(rows[e.rowIdx], { RcvTotalPrice: +roundTo((parseFloat(e.updated.RcvQuantity) || 0) * (parseFloat(rows[e.rowIdx].Product_id.NetWeight) || 0) * (parseFloat(rows[e.rowIdx].RcvUnitPrice) || 0), 2).toFixed(2) });
              Object.assign(rows[e.rowIdx], { RcvTotalWeight: +roundTo((parseFloat(e.updated.RcvQuantity) || 0) * (parseFloat(rows[e.rowIdx].Product_id.NetWeight) || 0), 2).toFixed(2) });
              Object.assign(rows[e.rowIdx], e.updated);
            } else {
              this.openSetWeight();
            }
          } else {
            if (rows[e.rowIdx].Product_id.ProductType === 'Per-Pound') {
              let RcvTotalWeight = (((parseFloat(e.updated.RcvQuantity))|| 0) * (parseFloat(rows[e.rowIdx].Product_id.NetWeight) || 0)).toFixed(2);
              if (isSH) {
                RcvTotalWeight = parseInt(RcvTotalWeight);
              }
              if (isABBLE) {
                RcvTotalWeight = RcvTotalWeight * rows[e.rowIdx].purchase_convert_unit
              }
              let RcvTotalPrice = +roundTo(((parseFloat(e.updated.RcvQuantity)) || 0) * (parseFloat(rows[e.rowIdx].Product_id.NetWeight) || 0) * (parseFloat(rows[e.rowIdx].RcvUnitPrice) || 0), 2).toFixed(2);
              if(isGGI) {
                RcvTotalPrice = +roundTo(((parseFloat(e.updated.RcvQuantity)) || 0) * (parseFloat(rows[e.rowIdx].Product_id.NetWeight) || 0) * (parseFloat(rows[e.rowIdx].small_unit_price) || 0), 2).toFixed(2);
              }
              if (isABBLE) {
                RcvTotalPrice = (RcvTotalWeight * (parseFloat(rows[e.rowIdx].RcvUnitPrice) || 0)).toFixed(2)
              }
              const temp = {
                RcvTotalPrice,
                RcvTotalWeight,
                TotalNetWeight: parseInt((((parseFloat(e.updated.RcvQuantity)) || 0) * (parseFloat(rows[e.rowIdx].Product_id.NetWeight) || 0)).toFixed(2)),
                ...e.updated,
              };
              Object.assign(rows[e.rowIdx], temp);
            } else {
              let RcvTotalWeight = (((parseFloat(e.updated.RcvQuantity)) || 0) * (parseFloat(rows[e.rowIdx].Product_id.NetWeight) || 0)).toFixed(2);
              let RcvTotalPrice = +roundTo(((parseFloat(e.updated.RcvQuantity))|| 0) * (parseFloat(rows[e.rowIdx].RcvUnitPrice) || 0), 2).toFixed(2);
              if (isSH) {
                RcvTotalWeight = parseInt(RcvTotalWeight);
              }
              if (isABBLE) {
                RcvTotalWeight = RcvTotalWeight * rows[e.rowIdx].purchase_convert_unit
                RcvTotalPrice = (RcvTotalPrice * (rows[e.rowIdx].purchase_convert_unit || 1)).toFixed(2);
              }
              const temp = {
                RcvTotalPrice,
                RcvTotalWeight,
                TotalNetWeight: parseInt(((parseFloat(e.updated.RcvQuantity) || 0) * (parseFloat(rows[e.rowIdx].Product_id.NetWeight) || 0)).toFixed(2)),
                ... e.updated,
              };
              Object.assign(rows[e.rowIdx], temp);
            }
          }
          if (isVAK) {
            Object.assign(rows[e.rowIdx], { location: ''});
          }
        } else if (e.updated.RcvUnitPrice != null || (isGGI && e.updated.small_unit_price != null)) {
          if (rows[e.rowIdx].Product_id.ProductType == 'Non-Fixed' || rows[e.rowIdx].Product_id.ProductType === 'Per-Pound') {
            if(isGGI) {
              Object.assign(rows[e.rowIdx], { RcvTotalPrice: +roundTo((parseFloat(e.updated.small_unit_price) || 0) * (parseFloat(rows[e.rowIdx].RcvTotalWeight) || 0), 2).toFixed(2) });
            } else {
              Object.assign(rows[e.rowIdx], { RcvTotalPrice: +roundTo((parseFloat(e.updated.RcvUnitPrice) || 0) * (parseFloat(rows[e.rowIdx].RcvTotalWeight) || 0), 2).toFixed(2) });
            }
          } else {
            Object.assign(rows[e.rowIdx], { RcvTotalPrice: +roundTo((parseFloat(e.updated.RcvUnitPrice) || 0) * (parseFloat(rows[e.rowIdx].RcvQuantity) || 0), 2).toFixed(2) });
          }
          Object.assign(rows[e.rowIdx], e.updated);
        } else if(isCCW && e.updated.package_date != null) {
          let shiftLife = rows[e.rowIdx].Product_id.ShiftLife || 0;
          let expTm = moment(e.updated.package_date).add(shiftLife, 'days').format('MM-DD-YYYY');
          Object.assign(rows[e.rowIdx], { package_date: e.updated.package_date, expire_datetime:expTm});
        }

        // if(e.cellKey == 'RcvQuantity') {
        //   Object.assign(rows[e.rowIdx], e.updated);
        //   // totalLoaded: null,
        //   // rowChosen: null,
        // }
        else if (e.updated.RcvTotalWeight != null) {
          if (rows[e.rowIdx].Product_id.ProductType === 'Non-Fixed' || rows[e.rowIdx].Product_id.ProductType === 'Per-Pound') {
            Object.assign(rows[e.rowIdx], { RcvTotalPrice: +roundTo((parseFloat(e.updated.RcvTotalWeight) || 0) * (parseFloat(rows[e.rowIdx].RcvUnitPrice) || 0), 2).toFixed(2) });
            if(isGGI) {
              if(rows[e.rowIdx].Product_id.ProductType === 'Non-Fixed') {
                Object.assign(rows[e.rowIdx], { RcvTotalPrice: +roundTo((parseFloat(e.updated.RcvTotalWeight) || 0) * (parseFloat(rows[e.rowIdx].small_unit_price) || 0), 2).toFixed(2) });
                Object.assign(rows[e.rowIdx], { RcvUnitPrice: +roundTo((parseFloat(e.updated.RcvTotalWeight / rows[e.rowIdx].RcvQuantity) || 0) * (parseFloat(rows[e.rowIdx].small_unit_price) || 0), 2).toFixed(2)});
              }
            }
            if (isVAK) {
              Object.assign(rows[e.rowIdx], {RcvQuantity: parseFloat(e.updated.RcvTotalWeight / rows[e.rowIdx].Product_id.NetWeight)});
            }
            Object.assign(rows[e.rowIdx], e.updated);
          }
          if (isVAK) {
            Object.assign(rows[e.rowIdx], { location: ''});
          }
          if(isLAP) {
            let length = rows[e.rowIdx].RcvQuantity;
            let avgWeight = (parseFloat(e.updated.RcvTotalWeight || 0)) / (parseFloat(length) || 1);
            avgWeight = (Math.floor(avgWeight * 100) / 100).toFixed(2);
            const diff = (parseFloat(e.updated.RcvTotalWeight || 0)) - (avgWeight * length);
            let cpWeights = [];
            for(let i=0; i < length; i++) {
              if(i != length-1) {
                cpWeights.push({Weight:avgWeight});
              } else {
                cpWeights.push({Weight:((parseFloat(avgWeight || 0) + diff) || 0).toFixed(2)});
              }
            }
            rows[e.rowIdx].subWeights = cpWeights;
            Object.assign(rows[e.rowIdx]);
          }
        } else {
          Object.assign(rows[e.rowIdx], e.updated);
        }
        let totalPrice = 0;
        rows.map((r) => {
          totalPrice += parseFloat(Math.round((parseFloat(r.RcvTotalPrice) || 0) * 100) / 100);
        });
        // totalPrice = parseFloat(Math.round(totalPrice * 100) / 100).toFixed(2);
        totalPrice = +parseFloat(totalPrice).toFixed(2);
        const newInventories = { ...receivedInventories, rows };
        this.setState({
          receivedInventories: newInventories,
          totalPrice,
        });
      };

      // Handle the row select function

      const onRowSelect = (rows) => {
        const receivedInventories = { ...this.state.receivedInventories, selectedRows: rows };
        this.setState({ receivedInventories });
      };

      const onRowsSelected = (rows) => {
        const newRows = getRows();
        const selectedRows = [...this.state.receivedInventories.selectedRows];

        rows.map((r) => {
          newRows[r.rowIdx].isSelected = true;
          selectedRows.push(r.row);
        });
        const receivedInventories = {
          ...this.state.receivedInventories,
          rows: newRows,
          selectedRows,
        };
        this.setState({ receivedInventories });
      };

      const onRowsDeselected = (rows) => {
        const newRows = [...this.state.receivedInventories.rows];
        let selectedRows = [...this.state.receivedInventories.selectedRows];
        rows.map((r) => {
          newRows[r.rowIdx].isSelected = false;
          selectedRows = _.filter(
            selectedRows,
            row => r.row.PurchaseOrderLine_id !== row.PurchaseOrderLine_id,
          );
          /* code below removes incorrect row */
          // const rowIndex = selectedRows.indexOf(r.row);
          // selectedRows.splice(rowIndex, 1);
        });
        const receivedInventories = { ...this.state.receivedInventories, rows: newRows, selectedRows };
        this.setState({ receivedInventories });
      };

      // Custom Formatter component

      const NameFormatter = React.createClass({
        render() {
          if (this.props.value) return <span>{this.props.value.Name}</span>;
          return <span className="label label-danger">-</span>;
        },
      });

      const IsVariableFormatter = React.createClass({
        render() {
          const { dependentValues, value } = this.props;
          let quantity;
          if (dependentValues.ReceivedQuantity) {
            quantity = `${dependentValues.ReceivedQuantity}/${value}`;
          } else {
            quantity = `0/${value}`;
          }
          let type = '';
          if (dependentValues.Product_id.ProductType === 'Non-Fixed') {
            type = <label className="label label-success"><Translate value="non_fixed" /></label>;
          } else if (dependentValues.Product_id.ProductType === 'Per-Pound') {
            type = <label className="label label-primary"><Translate value="per_pound" /></label>;
          }
          return <span>{ quantity } { type }</span>;
        },
      });

      const IsPalletFormatter = React.createClass({
        render() {
          const { dependentValues, value } = this.props;
          const CalcoDispatchCase = dependentValues.Product_id.CalcoDispatchCase;
          const RcvQuantity = dependentValues.RcvQuantity;

          let palletQty;
          if (isOCM && CalcoDispatchCase > 0 && RcvQuantity > 0) {
            palletQty = Math.ceil(RcvQuantity/CalcoDispatchCase);
          } else {
            palletQty = '';
          }

          return <span>{ palletQty }</span>;
        },
      });

      //B:{dependentValues.Product_id.CalcoDispatchCase}

      const RcvTotalWeightFormatter = React.createClass({
        render() {
          const { dependentValues, value } = this.props;
          if (dependentValues.Product_id && dependentValues.Product_id.ProductType !== 'Per-Pound') {
            return <span>{ value }</span>;
          }
          const totalNetWeight = (parseInt(dependentValues.RcvQuantity, 10) || 0) * dependentValues.Product_id.NetWeight;
          return <span>{ totalNetWeight }</span>;
        },
      });

      const expireParams = isCCW ? {
        getRowMetaData: (row) => row,
        editor: DateEditor,
      } : {};

      // Column difinition
      const columns = [
        ...isVAK ? [] : [{
          // key: 'ProductNum',
          name: <Translate value="action" />,
          resizable: true,
          sortable: true,
          width: 95,
          // filterable: true,
          formatter: ({ dependentValues }) => {
            return (<Button
              bsStyle="primary"
              type="button"
              onClick={() => {
                const receivedInventoriesRows = [...this.state.receivedInventories.rows];
                const duplicateRow = { ...dependentValues, RcvQuantity: 0, uniqID: receivedInventoriesRows.length + 1 };
                let lastIndexOfProduct = 0;
                receivedInventoriesRows.forEach((row, index) => {
                  if (row.ProductNum === duplicateRow.ProductNum) {
                    lastIndexOfProduct = index;
                  }
                });
                receivedInventoriesRows.splice(lastIndexOfProduct + 1, 0, duplicateRow);
                this.setState({
                  receivedInventories: {
                    ...this.state.receivedInventories,
                    rows: receivedInventoriesRows,
                  }
                })
                // this.props.printWarehouseReceive(createdReceive.WarehouseReceiveNum);
              }}
            >
              <Translate value="duplicate" />
            </Button>)
            // return <span>duplicate</span>
          },
          getRowMetaData: row => row,
        }],
        ...isOLG ? [] : [{
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 65,
          filterable: true,
        }],
        {
          key: 'ProductName',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: 200,
          filterable: true,
        },
        {
          key: 'RefNum',
          name: <Translate value={isOLG ? "item_no" : isVAK ? "sku" : "ref_num"} />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'ProductDescription',
          name: <Translate value="desc" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
        },
        {
          key: 'Quantity',
          name: <Translate value="qty" />,
          resizable: true,
          sortable: true,
          width: 60,
          filterable: true,
          formatter: IsVariableFormatter,
          getRowMetaData: row => row,
        },
        {
          key: 'RcvQuantity',
          name: <Translate value="rcv_qty" />,
          resizable: true,
          editable: true,
          sortable: true,
          width: 60,
          filterable: true,
        },
        ...isVAK ? [] : [{
          key: 'location',
          name: <Translate value="location" />,
          resizable: true,
          // editable: true,
          sortable: true,
          width: 90,
          filterable: true,
          getRowMetaData: row => row,
          formatter: (props, index) => {
            const {
              dependentValues,
            } = props;
            return <div style={{ width: '100%', height: '20px', }} onDoubleClick={(e) => {
              e.preventDefault();
              this.setState({
                editingLine: dependentValues,
              });
              this.setLocationSelectModalVisibility(true);
            }}>{dependentValues.location}</div>
          }
        }],
        ...isGGI ? [
          {
            key: 'ggi_batch',
            name: <Translate value="ggi_batch" />,
            resizable: true,
            editable: true,
            sortable: true,
            width: 60,
            filterable: true,
          },
          {
            key: 'lot_num',
            name: <Translate value="lot_no" />,
            resizable: true,
            editable: true,
            sortable: true,
            width: 60,
            filterable: true,
          },
        ]:[],
        {
          key: 'RcvTotalWeight',
          name: this.renderReceiveTotalWeightName(),
          resizable: true,
          editable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'RcvTotalPrice',
          name: <Translate value="receive_total_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true
      },
        ...isVAK ? [] : [{
          key: 'expire_datetime',
          name: <Translate value="expire_datetime" />,
          resizable: true,
          editable: true,
          sortable: true,
          width: 150,
          filterable: true,
          ...expireParams,
        }],
        {
          key: 'Remark',
          name: <Translate value="remark" />,
          resizable: true,
          sortable: true,
          editable: true,
          width: 80,
          filterable: true,
        },
      ];

      if (isUSPride) {
        const index1 = _.findIndex(columns, { key: "RcvTotalWeight" });
        const temp1 = {
          key: "unit_price",
          name: <Translate value="unit_cost" />,
          resizable: true,
          width: 70,
          sortable: true,
        };
        columns.splice(index1, 1, temp1);

        const index2 = _.findIndex(columns, { key: "expire_datetime" });
        const temp2 = {
          key: "PackageSize_1",
          name: <Translate value="volume_cft" />,
          resizable: true,
          width: 80,
          sortable: true,
        };
        columns.splice(index2, 1, temp2);
      }

      if (isGGI) {
        const expIdx = _.findIndex(columns, { key: "expire_datetime" });
        const case_per_layer = {
          key: "case_per_layer",
          name: <Translate value="case_per_layer" />,
          resizable: true,
          width: 120,
          sortable: true,
          editable: true,
        };
        const layer_per_pallet = {
          key: "layer_per_pallet",
          name: <Translate value="layer_per_pallet" />,
          resizable: true,
          width: 120,
          sortable: true,
          editable: true,
        }
        columns.splice(expIdx, 0, case_per_layer, layer_per_pallet);
      }

      if (isLAP || isCCW) {
        const expIdx = _.findIndex(columns, { key: "expire_datetime" });
        let packDateParams = isCCW ? {
          getRowMetaData: row => row,
          editor: DateEditor,
        } : {}
        if (expIdx !== -1) {
          columns.splice(expIdx, isCCW ? 0:1, {
            key: 'package_date',
            name: <Translate value="package_date" />,
            resizable: true,
            editable: true,
            sortable: true,
            width: 150,
            filterable: true,
            ...packDateParams,
          })
        }
      }
      if (isVAK) {
        const rcvTotalWtIndex = columns.findIndex(column => column.key === 'RcvTotalWeight');
        if (rcvTotalWtIndex !== -1) {
          columns.splice(rcvTotalWtIndex, 0, {
            key: 'TotalNetWeight',
            name: <Translate value="total_wt" />,
            resizable: true,
            sortable: true,
            width: 60,
            filterable: true,
            formatter: IsVariableFormatter,
            getRowMetaData: row => row,
          });
        }
      }

      return (
        <Row>
          <Col sm={12}>
            <div style={{ maxWidth: '100%' }} id="ReceiveForm-dataGrid2" className='over_visible'>
              <ReactDataGrid
                rowKey="ProductNum"
                enableCellSelect
                onGridSort={handleGridSort}
                columns={columns}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                rowHeight={25}
                headerRowHeight={45}
                minHeight={isCCW ? 576 : this.state.tableHeight}
                onRowUpdated={handleRowUpdated}
                enableRowSelect="single"
                rowSelection={{
                  showCheckbox: true,
                  onRowsSelected,
                  onRowsDeselected,
                  selectBy: {
                    isSelectedKey: 'isSelected',
                  },
                }}
              />
            </div>
          </Col>
        </Row>
      );
    }

    handleFormSubmit() {
      let formProps = {
        InvoiceNum: this.props.InvoiceNum,
        PackingNum: this.props.PackingNum,
        PostingDate: this.props.PostingDate,
        InvoiceDate: this.props.InvoiceDate,
        container_num: this.props.container_num,
        vendor_id: this.props.vendor_id,
        cso_num: this.props.cso_num
      };
      if(isGGI) {
        formProps.container_num = this.props.container_num;
        formProps.cso_num = this.props.cso_num;
      }
      // var receiveLines = this.state.receivedInventories.rows;
      // var partialReceived = false;
      // receiveLines.map(receiveLine => {
      //   if(receiveLine.RcvQuantity < receiveLine.Quantity) {
      //     partialReceived = true;
      //   }
      // })
      // if(partialReceived){
      //   this.setState({ case: 'completeSheet', caseAction: this.createReceive, formProps: formProps, confirmOpen: true })
      //   // var r1 = confirm('sheet is not fully received!');
      //   // if(r1 == false){
      //   //   return;
      //   // }
      // }
      // else {
      this.createReceive(formProps, false);
      // }
    }

    debouncedCreateReceive = _.debounce((
      PostingDate,
      InvoiceDate,
      HandlingCost,
      MiscCost,
      ShippingCost,
      LocalShipCost,
      StorageCost,
      CustomCost,
      OtherCost,
      OverseaShipCost,
      priceAdjustment,
      ShareCost,
      PONum,
      Note,
      Warehouse_id,
      VendorPicklistNum,
      vendor_id,
      ReceivingPrice,
      InvoiceFinalPrice,
      Warehouse_Receive_Line,
      formProps,
      completeReceive,
      // SyncAp,
      success,
    ) => {
      if(isGGI) {
        this.props.createReceive(
          PostingDate,
          InvoiceDate,
          HandlingCost,
          MiscCost,
          ShippingCost,
          priceAdjustment,
          ShareCost,
          PONum,
          Note,
          Warehouse_id,
          VendorPicklistNum,
          vendor_id,
          ReceivingPrice,
          InvoiceFinalPrice,
          Warehouse_Receive_Line,
          formProps,
          completeReceive,
          // SyncAp,
          success,
          LocalShipCost,
          StorageCost,
          CustomCost,
          OtherCost,
          OverseaShipCost,
        );
      } else {
        this.props.createReceive(
          PostingDate,
          InvoiceDate,
          HandlingCost,
          MiscCost,
          ShippingCost,
          priceAdjustment,
          ShareCost,
          PONum,
          Note,
          Warehouse_id,
          VendorPicklistNum,
          vendor_id,
          ReceivingPrice,
          InvoiceFinalPrice,
          Warehouse_Receive_Line,
          formProps,
          completeReceive,
          // SyncAp,
          success,
        );
      }
    }, 500, { maxWait: 1500 })

    createReceive(formProps, completeReceive) {
      this.setState({ dirty: false });
      const { currentReceive, currentReceiveDetail } = this.props;
      const { selectedProduct } = this.state;
      const rows = [...this.state.receivedInventories.rows];
      let Warehouse_Receive_Line;
      // filter out already received product with RcvQuantity and RcvTotalWeight = 0 unless new product added
      // if (selectedProduct.newProductAdded ) {
      //   Warehouse_Receive_Line = [...this.state.receivedInventories.rows];
      // } else {
      Warehouse_Receive_Line = rows.filter(row => !((row.ReceivedQuantity > 0) &&
         (row.RcvQuantity == 0) && // Field may be string type
         (row.RcvTotalWeight == 0)), // Field may be string type
        );
        // }
      Warehouse_Receive_Line = Warehouse_Receive_Line.filter(line => line.RcvQuantity > 0);
      const validateRcvQuantity = Warehouse_Receive_Line.every(line => line.RcvQuantity > 0);
      const validateRcvTotalWeight = Warehouse_Receive_Line.every(line => (
        line.Product_id.ProductType !== 'Non-Fixed' && line.Product_id.ProductType !== 'Per-Pound') || line.RcvTotalWeight > 0);

      const invalidIndex = [];
      let validExpireDateTime = true;
      if (!isLAP) {
        validExpireDateTime = Warehouse_Receive_Line.every((line, idx) => {
          if (!moment(line.expire_datetime).isValid()) {
            invalidIndex.push(idx + 1);
          };
          return moment(line.expire_datetime).isValid() || line.expire_datetime === "" || line.expire_datetime === null
        });
      }
      let validPackageDate = true;
      if (isLAP || isCCW) {
        validPackageDate = Warehouse_Receive_Line.every((line, idx) => {
          if (!moment(line.package_date).isValid()) {
            invalidIndex.push(idx + 1);
          };
          return line !== undefined && moment(line.package_date).isValid() && line.package_date !== "" && line.package_date !== null
        });
      }
      if (isVAK) {
        Warehouse_Receive_Line.forEach(line => {
          line.zone_num = line.location;
        });
      }
      const validateCasePerLayerAndLayerPerPallet = rows.every(line => {
        return isGGI && line.RcvQuantity == 0 || line.case_per_layer && line.layer_per_pallet && isInteger(Number(line.case_per_layer)) && isInteger(Number(line.layer_per_pallet));
      });

      const validatePalletLayer = isGGI ? validateCasePerLayerAndLayerPerPallet : true;

      if (validateRcvQuantity && validateRcvTotalWeight && validExpireDateTime && validPackageDate && validatePalletLayer) {
        const success = () => {
          this.setState({
            case: "receiveformSaveSuccess",
            confirmOpen: true,
            caseAction: () => {
              this.context.router.push('/inventories/receive');
            }
          })
        }
        this.debouncedCreateReceive(
          this.props.PostingDate,
          this.props.InvoiceDate,
          this.props.HandlingCost,
          this.props.MiscCost,
          this.props.ShippingCost,
          this.props.LocalShipCost,
          this.props.StorageCost,
          this.props.CustomCost,
          this.props.OtherCost,
          this.props.OverseaShipCost,
          this.props.priceAdjustment,
          this.props.ShareCost,
          currentReceive.PONum,
          this.props.note,
          (this.props.Warehouse && this.props.Warehouse.value) || currentReceive.Warehouse_id || currentReceiveDetail.Deliver_Warehouse_id_id,
          this.props.currentReceiveDetail.VendorNum,
          (this.props.vendor_id ? this.props.vendor_id : this.props.currentReceiveDetail.vendor_id),
          this.props.ReceivingPrice,
          parseFloat(this.props.InvoiceFinalPrice),
          Warehouse_Receive_Line,
          formProps,
          completeReceive,
          // this.state.SyncAp,
          success
        );
      } else if (!validateRcvQuantity) {
        alert('Receive Quantity Should Be Larger Than Zero!');
      } else if (!validateRcvTotalWeight) {
        alert('For Non-Fixed Product, Receive Total Weight Should Be Larger Than Zero!');
      } else if (!validExpireDateTime) {
        alert(`Please Enter a Valid Date! (MM-DD-YYYY) line: ${invalidIndex.join(',')}`);
      } else if (!validPackageDate){
        alert(`Please Enter a Valid Date! (MM-DD-YYYY) line: ${invalidIndex.join(',')}`);
      } else if (isGGI && !validateCasePerLayerAndLayerPerPallet) {
        alert(`Cases per layer and Layers per pallet must be valid integers.`);
      }
    }

    renderPOInformation() {
      const { currentReceiveDetail } = this.props;
      const defaultWarehouseID = { value: currentReceiveDetail && currentReceiveDetail.Deliver_Warehouse_id_id };
      let Total = 0,
        Final = 0,
        HandlingCost = null,
        MiscCost = null,
        ShippingCost = null,
        priceAdjustment = null,
        ShareCost = false,
        RCVTotal = 0,
        RCVFinal = 0,
        TaxableItems = 0,
        InvoiceFinalPrice = 0,
        TotalCRV = 0,
        TaxRate = 0;
      Total = currentReceiveDetail && currentReceiveDetail.TotalPrice;
      Final = currentReceiveDetail && currentReceiveDetail.FinalPrice;
      HandlingCost = (this.state.HandlingCost || this.state.HandlingCost == 0) ? this.state.HandlingCost : currentReceiveDetail && currentReceiveDetail.HandlingCost;
      MiscCost = (this.state.MiscCost || this.state.MiscCost == 0) ? this.state.MiscCost : currentReceiveDetail && currentReceiveDetail.MiscCost;
      ShippingCost = (this.state.ShippingCost || this.state.ShippingCost == 0) ? this.state.ShippingCost : currentReceiveDetail && currentReceiveDetail.ShippingCost;
      priceAdjustment = (this.state.priceAdjustment || this.state.priceAdjustment === 0) ? this.state.priceAdjustment : currentReceiveDetail && currentReceiveDetail.PriceAdjustment;
      ShareCost = (this.state.ShareCost) ? true : false;
      InvoiceFinalPrice = (this.state.InvoiceFinalPrice || this.state.InvoiceFinalPrice == 0) ? this.state.InvoiceFinalPrice : currentReceiveDetail && currentReceiveDetail.InvoiceFinalPrice;
      TaxRate = (this.state.TaxRate || this.state.TaxRate == 0) ? this.state.TaxRate : currentReceiveDetail && currentReceiveDetail.TaxRate;
      TotalCRV = (this.state.TotalCRV || this.state.TotalCRV == 0) ? this.state.TotalCRV : 0;

      const details = (this.state.receivedInventories.rows.length) ? this.state.receivedInventories.rows : [];
      for (let i = 0; i < details.length; i++) {
        const RcvQuantity = +details[i].RcvQuantity;
        const FOBUnitPrice = details[i].FOBUnitPrice;
        if (details[i].Product_id.ProductType === 'Fixed' || (isABBLE && (details[i].Product_id.ProductType === 'Non-Product' || details[i].Product_id.ProductType === 'Service'))) {
          if (isHMM && details[i].package_size.split('SFT').length > 1) {
            RCVTotal += roundTo(RcvQuantity * FOBUnitPrice * Number(details[i].package_size.split('SFT')[0]), 2);
            if (details[i].Product_id.IsTaxable) { TaxableItems += roundTo(RcvQuantity * FOBUnitPrice * Number(details[i].package_size.split('SFT')[0]), 2); }
            RCVFinal += roundTo(RcvQuantity * FOBUnitPrice * Number(details[i].package_size.split('SFT')[0]), 2);
          } else {
            if (isABBLE) {
              RCVTotal += roundTo(RcvQuantity * details[i].RcvUnitPrice * (details[i].purchase_convert_unit || 1), 2);
              RCVFinal += roundTo(RcvQuantity * details[i].RcvUnitPrice * (details[i].purchase_convert_unit || 1), 2);
            } else {
              RCVTotal += roundTo(RcvQuantity * FOBUnitPrice, 2);
              RCVFinal += roundTo(RcvQuantity * FOBUnitPrice, 2);
            }
            if (details[i].Product_id.IsTaxable) { TaxableItems += roundTo(RcvQuantity * FOBUnitPrice, 2); }
          }
        } else {
          const RcvTotalWeight = details[i].RcvTotalWeight;
          if(isGGI) {
            RCVTotal += roundTo(details[i].small_unit_price * RcvTotalWeight, 2);
            RCVFinal += roundTo(details[i].small_unit_price * RcvTotalWeight, 2);
          } else {
            RCVTotal += roundTo(FOBUnitPrice * RcvTotalWeight, 2);
            RCVFinal += roundTo(FOBUnitPrice * RcvTotalWeight, 2);
          }
          if (details[i].Product_id.IsTaxable) { TaxableItems += roundTo(FOBUnitPrice * RcvTotalWeight, 2); }

        }
        TotalCRV += roundTo(details[i].Product_id.CRV * RcvQuantity, 2);
      }
      TaxableItems = roundTo((TaxableItems * (TaxRate / 100)), 2);
      RCVFinal += roundTo(parseFloat(ShippingCost), 2) + roundTo(parseFloat(HandlingCost), 2) + roundTo(parseFloat(priceAdjustment), 2) + roundTo(parseFloat(MiscCost), 2) + TotalCRV + TaxableItems;
      if (RCVFinal) {
        RCVTotal = +roundTo(RCVTotal, 2).toFixed(2);
        RCVFinal = +roundTo(RCVFinal, 2).toFixed(2);
      } else {
        RCVTotal = currentReceiveDetail && currentReceiveDetail.TotalPrice;
        RCVFinal = currentReceiveDetail && currentReceiveDetail.FinalPrice;
        if (isCPG || isVIP) {
          RCVTotal = 0;
          RCVFinal = 0;
        }
      }

      let renderVendorInvNo =  <Field name="InvoiceNum" component={InputField} />;
      // if (isGGI) {
      //   renderVendorInvNo = <Field name="cso_num" component={InputField} disabled/>
      // }
      return (
        <Panel>
          <Col xs={2}>
            <label className="receive-form-label"><Translate value="details" /></label>
            <Row>
              <Col sm={12}>
                <label><Translate value="receipt_no" /></label>
              </Col>
            </Row>
            <Row>
              <label className="col-sm-5 marginTopStyle po-information" ><Translate value="vendor_inv" /></label>
              <Col sm={7}>
                {renderVendorInvNo}
              </Col>
            </Row>
            <Row>
              <label className="col-sm-5 marginTopStyle po-information" ><Translate value="packing_num" /></label>
              <Col sm={7}>
                <Field name="PackingNum" component={InputField} />
              </Col>
            </Row>
            <Row>
              <label className="col-sm-5 marginTopStyle po-information" ><Translate value="warehouse" /></label>
              <Col sm={7}>
                <WarehouseDropdown defaultValue={defaultWarehouseID} Company_id={this.state.Company_id_id}/>
              </Col>
            </Row>
            {isTN &&
              <Row>
                <label className="col-sm-5 marginTopStyle po-information" ><Translate value="container_no" />.</label>
                <Col sm={7} style={{marginTop: '5px'}}>
                  {/* <Field name="container_num" component={InputField} /> */}
                  {this.props.container_num}
                </Col>
              </Row>
            }
            {isSV &&
              <Row>
                <label className="col-sm-5 marginTopStyle po-information" ><Translate value="container_no" />.</label>
                <Col sm={7} style={{marginTop: '5px'}}>
                  <Field name="container_num" component={InputField} />
                  {/* {this.props.container_num} */}
                </Col>
              </Row>
            }
            {isGGI && <Row>
                <label className="col-sm-5 marginTopStyle po-information" ><Translate value="container_no" /></label>
                <Col sm={7} style={{marginTop: '5px'}}>
                  <Field name="container_num" component={InputField} />
                </Col>
                <label className="col-sm-5 marginTopStyle po-information" ><Translate value="cso_no" /></label>
                <Col sm={7} style={{marginTop: '5px'}}>
                  <Field name="cso_num" component={InputField} />
                </Col>
              </Row>}
          </Col>
          <Col xs={2}>
            <label className="receive-form-label"><Translate value="vendor" /></label>
            {/* <Row>
              <Col sm={6}>
                <label><Translate value="vendor_id" /></label>
              </Col>
              <Col sm={6}>
                {this.state.vendorNum}
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <label><Translate value="name" /></label>
              </Col>
              <Col sm={6}>
                {this.state.vendorName}
              </Col>
            </Row> */}
{/* lalala */}
            <Row>
                  <Col sm={ 3 }>
                    <label><Translate value="id" /></label>
                  </Col>
                  <Col sm={ 9 }>
                  <Field name="vendor_id" component={ Selection } withRef={true} ref="vendorOptions" options={this.state.vendorOptions2} onKeyPress={(event) => {
        }}/>
                  </Col>
              </Row>
              <Row>
                  <Col sm={ 3 }>
                    <label><Translate value="name" /></label>
                  </Col>
                  <Col sm={ 9 }>
                  <Field name="vendor_id" component={ Selection } withRef={true} ref="vendorOptions" options={this.state.vendorOptions1} onKeyPress={(event) => {
        }}/>
                  </Col>
              </Row>
            <Row>
              <Col sm={6}>
                <label><Translate value="description" /></label>
              </Col>
              <Col sm={6}>
                {this.state.vendorDescription}
              </Col>
            </Row>
          </Col>
          <Col xs={2}>
            <label className="receive-form-label"><Translate value="dates" /></label>
            <Row>
              <Col sm={6}>
                <label><Translate value="order_date" /></label>
              </Col>
              <Col sm={6}>
                {this.state.orderDate ? convertLocalDate(this.state.orderDate, 'MM-DD-YY') : null}
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <label><Translate value="eta_date" /></label>
              </Col>
              <Col sm={6}>
                {this.state.ETADate ? convertLocalDate(this.state.ETADate, 'MM-DD-YY') : null}
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <label><Translate value="receive_date" /></label>
              </Col>
              <Col sm={6}>
                <Field component={DatePicker} name="PostingDate" />
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <label><Translate value="vendor_inv_date" /></label>
              </Col>
              <Col sm={6}>
                <Field component={DatePicker} name="InvoiceDate" />
              </Col>
            </Row>
          </Col>
          <Col xs={2}>
            <label className="receive-form-label"><Translate value="po_info" /></label>
            <Row>
              <Col sm={colWidth}>
                <label><Translate value="po_num" /></label>
              </Col>
              <Col sm={colWidth}>
                {this.state.PONum}
              </Col>
            </Row>
            <Row>
              <Col sm={colWidth}>
                <label><Translate value="purchaser" /></label>
              </Col>
              <Col sm={colWidth}>
                {this.state.purchaser}
              </Col>
            </Row>
            <Row>
              <Col sm={colWidth}>
                <label><Translate value="po_total" /></label>
              </Col>
              <Col sm={colWidth}>
                {'$'+numberWithCommas(Total)}
              </Col>
            </Row>
            <Row>
              <Col sm={colWidth}>
                <label><Translate value="po_final" /></label>
              </Col>
              <Col sm={6}>
                {'$'+numberWithCommas(Final)}
              </Col>
            </Row>
            <Row>
              <label className={isGGI ? 'col-sm-4 marginTopStyle' :'col-sm-6 marginTopStyle'} ><Translate value="note" /></label>
            </Row>
            <Row>
              <Col sm={colWidth}><Field name="Note" component={InputField} maxLength={150} style={{ minWidth: isGGI?'150px':'205px', maxWidth: isGGI?'150px':'205px' }} /></Col>
            </Row>
          </Col>
          <Col xs={2}>
            <label className="receive-form-label"><Translate value="price_details" /></label>
            <Row>
              <Col sm={6}>
                <label><Translate value="receive_total" /><span className="dollar-sign">$$</span></label>
              </Col>
              <Col sm={6}>
                <Field name="ReceiveTotal" component={DisabledInputField} placeholder={numberWithCommas(RCVTotal)} />
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <label><Translate value="receive_final" /><span className="dollar-sign">$$</span></label>
              </Col>
              <Col sm={6}>
                <Field name="ReceiveFinal" component={DisabledInputField} placeholder={numberWithCommas(RCVFinal)} />
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <label><Translate value="crv" /></label>
              </Col>
              <Col sm={6}>
                <Field name="TotalCRV" component={DisabledInputField} placeholder={numberWithCommas(TotalCRV)} />
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <label><Translate value="tax" /></label>
              </Col>
              <Col sm={6}>
                <Field name="TaxRate" component={InputField} />
              </Col>
            </Row>
            {
              isOCM &&
              <Row>
                <Col sm={6}>
                  <label><Translate value="share_cost" /></label>
                </Col>
                <Col sm={6}>
                  <Field name="ShareCost" component={Checkbox} />
                </Col>
              </Row>
            }
          </Col>
          <Col xs={2}>
            <label className="receive-form-label" />
            <Row>
              <Col sm={6}><label><Translate value='shipping'/><span className="dollar-sign">$$</span></label></Col>
              <Col sm={6}><Field name="ShippingCost" component={InputField} /></Col>
            </Row>
            <Row>
              <Col sm={6}><label><Translate value={ (isHMM || isUSPride) ? 'tax_amount' : 'handling' }/><span className="dollar-sign">{ isHMM ? '%' : '$$' }</span></label></Col>
              <Col sm={6}><Field name="HandlingCost" component={InputField} /></Col>
            </Row>
            <Row>
              <Col sm={6}><label><Translate value={ (isHMM || isUSPride) ? 'over_head' : 'misc' } /><span className="dollar-sign">{ isHMM ? '%' : '$$' }</span></label></Col>
              <Col sm={6}><Field name="MiscCost" component={InputField} /></Col>
            </Row>
            <Row>
              <Col sm={6}><label><Translate value="adjustments" /><span className="dollar-sign">$$</span></label></Col>
              <Col sm={6}><Field name="PriceAdjustment" component={InputField} /></Col>
            </Row>
            <Row>
              <Col sm={6}><label><Translate value="invoice_final" /><span className="dollar-sign">$$</span></label></Col>
              <Col sm={6}><Field name="InvoiceFinalPrice" component={InputField} /></Col>
            </Row>
          </Col>
           {isGGI && <Col xs={2}>
            <label className="receive-form-label"><Translate value="surcharge" /></label>
            <Row>
              <Col sm={6}><label><Translate value='local_ship'/><span className="dollar-sign">$$</span></label></Col>
              <Col sm={6}><Field name="LocalShipCost" component={InputField} /></Col>
            </Row>
            <Row>
              <Col sm={6}><label><Translate value={'storage' }/><span className="dollar-sign">{'$$' }</span></label></Col>
              <Col sm={6}><Field name="StorageCost" component={InputField} /></Col>
            </Row>
            <Row>
              <Col sm={6}><label><Translate value={'custom' } /><span className="dollar-sign">{'$$' }</span></label></Col>
              <Col sm={6}><Field name="CustomCost" component={InputField} /></Col>
            </Row>
            <Row>
              <Col sm={6}><label><Translate value="Other" /><span className="dollar-sign">$$</span></label></Col>
              <Col sm={6}><Field name="OtherCost" component={InputField} /></Col>
            </Row>
            <Row>
              <Col sm={6}><label><Translate value="oversea_ship" /><span className="dollar-sign">$$</span></label></Col>
              <Col sm={6}><Field name="OverseaShipCost" component={InputField} /></Col>
            </Row>
          </Col>}
        </Panel>
      );
    }

    complete() {
      // var receiveLines = this.state.receivedInventories.rows;
      // var partialReceived = false;
      // receiveLines.map(receiveLine => {
      //   if(receiveLine.RcvQuantity < receiveLine.Quantity) {
      //     partialReceived = true;
      //   }
      // })
      // if(partialReceived){
      this.setState({ case: 'completeSheet', caseAction: () => { this.completePurchaseOrder(); this.closeConfirm(); }, confirmOpen: true });
      // }
      // else {
      //   this.completePurchaseOrder();
      // }
      // var r = confirm(<Translate value="sheet_not_completed_warning" />);
      // if(r == true)
      //   this.props.completePurchaseOrder(this.props.currentReceive.PONum);  //provide po number here
    }

    completePurchaseOrder() {
      this.setState({ dirty: false });
      const formProps = {
        InvoiceNum: this.props.InvoiceNum,
        PackingNum: this.props.PackingNum,
        PostingDate: this.props.PostingDate,
        InvoiceDate: this.props.InvoiceDate,
        container_num: this.props.container_num,
        cso_num: this.props.cso_num
      };
      if(isGGI) {
        formProps.container_num = this.props.container_num;
        formProps.cso_num = this.props.cso_num;
      }
      // const { currentReceive } = this.props;
      // const rows = [...this.state.receivedInventories.rows];
      // const Warehouse_Receive_Line = rows.filter(
      //   row => !((row.ReceivedQuantity > 0) &&
      //           (row.RcvQuantity == 0) && // Field may be string type
      //           (row.RcvTotalWeight == 0)) // Field may be string type
      // );

      // const completeReceive = true;
      this.createReceive(formProps, true);

      // this.props.createReceive(
      //     this.props.HandlingCost,
      //     this.props.MiscCost,
      //     this.props.ShippingCost,
      //     currentReceive.PONum,
      //     this.props.note,
      //     currentReceive.Warehouse_id,
      //     this.props.currentReceiveDetail.VendorNum,
      //     this.props.currentReceiveDetail.Vendor_id,
      //     this.props.ReceivingPrice,
      //     parseFloat(this.props.InvoiceFinalPrice),
      //     Warehouse_Receive_Line,
      //     formProps,
      //     completeReceive
      //   )
    }
    cancelSetRow(rowChosen, tableChosen) {
      const rows = [...this.state[tableChosen]];
      if(rows.length == 0) {
        return
      }
      rows[rowChosen].RcvQuantity = this.state.oldQty;
      if (tableChosen == 'inventories') {
        const inventories = { ...this.state.inventories, rows };
        this.setState({ inventories });
      } else {
        const receivedInventories = { ...this.state.receivedInventories, rows };
        this.setState({ receivedInventories });
      }
    }
    setRows(rowChosen, tableChosen, weights) {
      const rows = [...this.state[tableChosen].rows];
      if (!isVAK) {
        rows[rowChosen].subWeights = weights;
      }
      const prevTotalPrice = parseFloat(rows[rowChosen].RcvTotalPrice) || 0;
      let sumWeights = 0;
      let autoCodeWeights = [];
      let packageDate = rows[rowChosen].package_date ? timeTOYmdOrMdy(rows[rowChosen].package_date) : '';
      if (!isVAK) {
        weights.map((w) => {
          sumWeights += parseFloat(w.Weight);
          if(isCCW) {
            autoCodeWeights.push({
              pack_time: packageDate, 
              prod_wt: parseFloat(w.Weight),
              prod_num: rows[rowChosen].product_num,
              prod_ref: rows[rowChosen].ref_num,
            });
          }
        });
      }
      rows[rowChosen].RcvQuantity = weights.length;
      rows[rowChosen].RcvTotalWeight = parseFloat(sumWeights).toFixed(2);
      if (isSH) {
        rows[rowChosen].RcvTotalWeight = parseInt(parseFloat(sumWeights).toFixed(2));
      }
      if (isABBLE) {
        rows[rowChosen].RcvTotalWeight = parseFloat(sumWeights).toFixed(2) * rows[rowChosen].purchase_convert_unit;
      }
      if(isGGI) {
        rows[rowChosen].RcvTotalPrice = parseFloat(sumWeights * (parseFloat(rows[rowChosen].small_unit_price) || 0)).toFixed(2);
        rows[rowChosen].RcvUnitPrice = Number(parseFloat((sumWeights/rows[rowChosen].RcvQuantity) * (parseFloat(rows[rowChosen].small_unit_price) || 0)).toFixed(2));
      } else {
        if(isLAP) {
          rows[rowChosen].RcvTotalPrice = +roundTo(parseFloat(sumWeights * (parseFloat(rows[rowChosen].RcvUnitPrice) || 0)), 2).toFixed(2);
        } else if (isABBLE) {
          rows[rowChosen].RcvTotalPrice = (rows[rowChosen].RcvTotalWeight * (parseFloat(rows[rowChosen].RcvUnitPrice) || 0)).toFixed(2);
        } else {
          rows[rowChosen].RcvTotalPrice = parseFloat(sumWeights * (parseFloat(rows[rowChosen].RcvUnitPrice) || 0)).toFixed(2);
        }
      }
      let totalPrice = (parseFloat(this.state.totalPrice) || 0) + (parseFloat(rows[rowChosen].RcvTotalPrice) || 0) - prevTotalPrice;
      totalPrice = parseFloat(Math.round(totalPrice * 100) / 100).toFixed(2);
      if (tableChosen == 'inventories') {
        const inventories = { ...this.state.inventories, rows };
        this.setState({ inventories, totalPrice });
        this.moveTo(rows[rowChosen]);
      } else {
        const receivedInventories = { ...this.state.receivedInventories, rows };
        this.setState({ receivedInventories, totalPrice });
      }
    }

    moveOff(row) {
      const inventories = { ...this.state.inventories };
      inventories.rows.push(row);
      const receivedInventories = { ...this.state.receivedInventories };
      const index = _.findIndex(receivedInventories.rows, { ProductNum: row.ProductNum });
      if (index > -1) { receivedInventories.rows.splice(index, 1); }
      this.setState({ receivedInventories, inventories });
    }

    moveTo(row) {
      const receivedInventoriesRows = [...this.state.receivedInventories.rows];
      const inventoriesRows = [...this.state.inventories.rows];
      if (isLAP) {
        row.location = row.Product_id.DefaultLocation;
      }
      if (isSV || isSH) {
        row.location = 'DZ';
      }
      if (isGGI) {
        if (!row.expire_datetime && row.expire_date) {
          row.expire_datetime = moment(row.expire_date).format('MM-DD-YYYY');
        }
      }
      if(isOLG) {
        receivedInventoriesRows.push({
          ...row,
          location: row.Location,
          uniqID: receivedInventoriesRows.length + 1,
        });
      } else {
        receivedInventoriesRows.push({
          ...row,
          uniqID: receivedInventoriesRows.length + 1,
        });
      }

      const index = _.findIndex(inventoriesRows, { ProductNum: row.ProductNum });
      if (index > -1) {
        inventoriesRows.splice(index, 1);
      }

      const receivedInventories = { ...this.state.receivedInventories, rows: receivedInventoriesRows.sort(sortByLineID) };
      const inventories = { ...this.state.inventories, rows: inventoriesRows };
      this.setState({ inventories, receivedInventories });
    }

    header() {
      return (
        <h2 className="mt0"><Translate value="receiving_information" /></h2>
      );
    }

    IFrameIsLoaded = () => {
      if (!this.state.PdfFrameLoaded) {
        const pdfFrame = window.frames.Pdf;
        pdfFrame.focus();
        pdfFrame.print();
        this.setState({ PdfFrameLoaded: true });
      }
    }

    renderIFrame() {
      if (this.props.warehouseReceivePdf) {
        const file = window.URL.createObjectURL(this.props.warehouseReceivePdf);
        return (
          <iframe style={{ display: 'none' }} onLoad={this.IFrameIsLoaded} id="Pdf" name="Pdf" src={file} />
        );
      }
    }

    renderPrint() {
      const { createdReceive } = this.props;
      let url = '';
      if (createdReceive && createdReceive.WarehouseReceiveNum) {
        url = `${ROOT_URL}v1/warehouse/receive/print/${createdReceive.WarehouseReceiveNum}?Bearer=${localStorage.getItem('token')}`;
      }
      return (
        <Button
          bsStyle="primary"
          type="button"
          onClick={() => {
            this.props.printWarehouseReceive(createdReceive.WarehouseReceiveNum);
          }}
          disabled={url === '' || !checkPermission('print_receive')}
        >
          <em className="fa fa-print" /><Translate value="print" />
        </Button>
      );
    }

    renderTotalWeightLabel = () => {
      if (isSH) return <label className="marginRightLabel"><Translate value="total_pcs" /></label>
      return <label className="marginRightLabel"><Translate value="total_weight" /></label>
    }

    render() {
      const { inventories, receivedInventories } = this.state;
      const { handleSubmit, isCreating, created, receiveLoading, currentReceiveDetail } = this.props;
      const createDialogStyle = {
        width: '500px',
        height: '550px',
        marginLeft: '-15%',
      };

      let totalUnit = 0;
      let totalUnitReceived = 0;
      let totalNetWeight = 0;
      const inventoriesRows = inventories.rows || [];
      const confirmSaveTitle = <Translate value="confirm_save" />;
      const confirmActionTitle = <Translate value="confirm_action" />;
      const receivedInventoriesRows = receivedInventories.rows || [];
      inventoriesRows.map((r) => {
        totalUnit += parseFloat(r.Quantity) || 0;
      });
      receivedInventoriesRows.map((r) => {
        totalUnitReceived += parseFloat(r.RcvQuantity) || 0;
        totalNetWeight += parseFloat(r.RcvTotalWeight) || 0;
      });

      totalNetWeight = parseFloat(Math.round(totalNetWeight * 100) / 100).toFixed(2);

      // let subWeights = [];
      // if(this.state.rowChosen && this.state.inventories.rows[this.state.rowChosen])
      //   subWeights = [...this.state.inventories.rows[this.state.rowChosen].subWeights];

    return (
        <ContentWrapper>
          <form method="get" action="#" >
            <Breadcrumb>
              <Breadcrumb.Item>
                <Translate value="warehouse_management" />
              </Breadcrumb.Item>
              <Breadcrumb.Item active="true">
                <Translate value="new_receiving" />
              </Breadcrumb.Item>
            </Breadcrumb>
            <ButtonToolbar>
              {false &&
                <Button bsStyle="success" disabled={created || !checkPermission('add_receive')} onClick={this.showSaveConfirmAP}><em className="fa fa-save" />&nbsp;Save & Sync AP</Button>
              }
              {
                !isSH &&
                <Button bsStyle="success" disabled={created || !checkPermission('add_receive')} onClick={this.showSaveConfirm}><em className="fa fa-save" />{false ? " Save & Sync" : <Translate value="save" />}</Button>
              }
              <Button bsStyle="primary" disabled={created || !checkPermission('add_receive')} onClick={() => this.complete()} > <Translate value="complete_this_sheet" />  </Button>
              { this.renderPrint() }
              <Button onClick={() => { this.context.router.push('/inventories/receive'); }} bsStyle="danger" ><em className="fa fa-close" /><Translate value="cancel" /></Button>
            </ButtonToolbar>
            <Grid fluid="true" >
              <Row>
                {this.header()}
                <Col sm={6}>
                  { this.props.isCreating || this.props.isEditing && <Spinner /> }
                  { this.props.createError && <div className="alert alert-danger" style={{ marginTop: '10px' }}>{JSON.stringify(this.props.createError)}</div> }
                </Col>
              </Row>
              <Row>
                {this.renderPOInformation()}
              </Row>
              { isMmDavis &&
                <Row style={{ marginTop: '8px', paddingBottom: '20px' }}>
                  <Panel>
                    <div id="autosuggest-div">
                      <Row style={{ height: '30px' }}>
                        <Col xs={12}>
                          <TypeRadios value={this.state.productSearchType} handleOptionChange={this.handleOptionChange} />
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={12}>
                          {this.renderAutoSuggest()}
                        </Col>
                      </Row>
                    </div>
                  </Panel>
                </Row>
              }
              <Row style={{ marginTop: '8px' }}>
                <Col xs={6} className="pl0">
                  <Panel>
                    <ButtonToolbar className="pull-right">
                      <Button
                        bsStyle="primary"
                        onClick={this.manualLoad}
                        disabled={this.state.inventories.selectedRows.length === 0}
                      >
                        <Translate value="load_fixed_manual" />&nbsp;<em className="fa fa-arrow-right" />
                      </Button>
                      <Button
                        bsStyle="success"
                        onClick={this.autoLoad}
                      >
                        <Translate value="load_fixed_all" />&nbsp;<em className="fa fa-arrow-right" />
                      </Button>
                    </ButtonToolbar>
                    <Row>
                      <Col xs={6}>
                        <h3><Translate value="not_yet_received" /></h3>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={4}>
                        <label className="marginRightLabel"><Translate value="purchase_status" /></label>
                        {this.props.currentReceive && <Translate value={this.props.currentReceive.PurchaseStatus} />}
                      </Col>
                      <Col sm={2}>
                        <label className="marginRightLabel"><Translate value="total_prod" /></label>
                        {this.state.inventories.rows.length}
                      </Col>
                      <Col sm={2}>
                        <label className="marginRightLabel"><Translate value="total_unit" /></label>
                        {totalUnit}
                      </Col>
                    </Row>
                    {this.renderTable() }
                  </Panel>
                </Col>
                <Col xs={6} >
                  <Panel>
                    <ButtonToolbar >
                      <Button
                        bsStyle="danger"
                        onClick={this.unload.bind(this, 'selection')}
                        disabled={this.state.receivedInventories.selectedRows.length === 0}
                      >
                        <em className="fa fa-times" /><Translate value="unload_selected" />
                      </Button>
                      <Button
                        bsStyle="primary"
                        onClick={this.unload.bind(this, 'all')}
                      >
                        <em className="fa fa-times" /><Translate value="reset_all" />
                      </Button>
                    </ButtonToolbar>
                    <Row>
                      <Col xs={6}>
                        <h3><Translate value="received" /></h3>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={3}>
                        <label className="marginRightLabel"><Translate value="total_prod" /> </label>
                        {this.state.receivedInventories.rows.length}
                      </Col>
                      <Col sm={3}>
                        <label className="marginRightLabel"><Translate value="total_unit" /> </label>
                        {totalUnitReceived}
                      </Col>
                      <Col sm={3}>
                        {this.renderTotalWeightLabel()}
                        {totalNetWeight}
                      </Col>
                    </Row>
                    {this.renderReceivingTable() }
                  </Panel>
                </Col>
              </Row>
            </Grid>
          </form>
          {this.renderIFrame()}
          <LocationSelectModal
            setModalVisibility={this.setLocationSelectModalVisibility}
            isVisible={this.state.isLocationSelectModalVisible}
            onConfirm={this.handleLocationSelect}
            selectedWarehouse={this.state.selectedWarehouse}
            editingLine={this.state.editingLine}
          />
          <SkyLightStateless
            dialogStyles={createDialogStyle}
            isVisible={this.state.confirmOpen}
            onCloseClicked={this.closeConfirm}
            title={confirmActionTitle}
          >
            <ConfirmActionModal
              case={this.state.case}
              formProps={this.state.formProps}
              caseAction={this.state.caseAction}
              closeC={this.closeConfirm}
              print={this.printReceive}
            />
          </SkyLightStateless>
          <SkyLightStateless
            dialogStyles={createDialogStyle}
            isVisible={this.state.saveConfirmOpen}
            onCloseClicked={this.closeSaveConfirm}
            title={confirmSaveTitle}
          >
            <br />
            <Row className="centerStyle"><h4><Translate value="are_you_sure_you_want_to_save_this_receiving" />?</h4></Row>
            <br />
            <br />
            <Row className="centerStyle">
              <Button
                bsStyle="primary"
                className="mr"
                onClick={() => { this.handleFormSubmit(); this.closeSaveConfirm(); }}
                type="button"
                // disabled={isCreating || created}
                disabled={receiveLoading || created}
              >
                <Translate value="yes" />
              </Button>
              <Button
                bsStyle="danger"
                onClick={() => { this.closeSaveConfirm(); }}
                type="button"
              >
                <Translate value="no" />
              </Button>
            </Row>
          </SkyLightStateless>
          <SkyLightStateless
            dialogStyles={{ ...createDialogStyle, height: '580px' }}
            isVisible={this.state.setWeightOpen}
            // onCloseClicked={()=>{this.cancelSetRow(this.state.rowChosen,this.state.tableChosen);this.closeSetWeight()}}
            onCloseClicked={this.closeSetWeight}
            title="Set Product Weights"
          >
            <SetReceiveWeightModal
              closeC={this.closeSetWeight}
              totalLoaded={this.state.totalLoaded}
              rowChosen={this.state.rowChosen}
              tableChosen={this.state.tableChosen}
              // cancelSetRow={this.cancelSetRow}
              rows={(this.state.rowChosen > -1) && (this.state[this.state.tableChosen].rows[this.state.rowChosen]) && (this.state[this.state.tableChosen].rows[this.state.rowChosen].subWeights) && [...this.state[this.state.tableChosen].rows[this.state.rowChosen].subWeights]}
              setRows={this.setRows}
              state={this.state}
            />
          </SkyLightStateless>
        </ContentWrapper>
      );
    }
}

export default ReceiveForm;

function roundTo(n, digits) {
  if (digits === undefined) {
    digits = 0;
  }

  const multiplicator = Math.pow(10, digits);
  n = parseFloat((n * multiplicator).toFixed(11));
  const test = (Math.round(n) / multiplicator);
  return +(test.toFixed(2));
}



// WEBPACK FOOTER //
// ./master/jsx/components/Inventories/receiveForm.jsx